/**
 * Preview Asset Module
 * Encapsulates all functionality for the asset preview page.
 */
const previewAssetModule = (function () {

    /**
     * The HTML template for the Asset Preview page.
     * This will be loaded into the content area when the module is activated.
     */
    const _templateHTML = `
    <!-- BEGIN CONTAINER -->
    <div id="viewAssetWrapper" class="page-container">
        <!-- BEGIN SIDEBAR -->
        <div class="page-sidebar-wrapper">
            <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
            <!-- DOC: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
            <div id="mySidebar" class="page-sidebar navbar-collapse collapse">
                <!-- BEGIN SIDEBAR MENU -->
                <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
                <!-- DOC: Apply "page-sidebar-menu-hover-submenu" class right after "page-sidebar-menu" to enable hoverable(hover vs accordion) sub menu mode -->
                <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
                <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
                <!-- DOC: Set data-keep-expand="true" to keep the submenues expanded -->
                <!-- DOC: Set data-auto-speed="200" to adjust the sub menu slide up/down speed -->

                <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu " data-keep-expanded="false"
                    data-auto-scroll="true" data-slide-speed="200">

                    <li class="customcolor">
                        <a href="javascript:;" data-module-action="loadIndex" >
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon home-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="homeButton"
                                    data-translation-default="Home">Home</span>
                            </div>
                        </a>
                    </li>

                    <li class="customcolor">
                        <a href="assetLibrary.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="Library" class="side-bar-icon library-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="libraryButton"
                                    data-translation-default="Library">Library</span>
                            </div>
                        </a>
                    </li>

                    <li id="favouritesSideMenuIcon" class="customcolor">
                        <a href="javascript:;" data-module-action="loadFavourites">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon favourites-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="favouritesButton"
                                    data-translation-default="Favourites">Favourites</span>
                            </div>
                        </a>
                    </li>

                    <li id="inboxSideMenuIcon" style="display:none" class="customcolor">
                        <a href="inbox.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon inbox-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-inbox-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="inboxButton"
                                    data-translation-default="Inbox">Inbox</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="cartSideMenuIcon" class="customcolor">
                        <a href="javascript:;" data-module-action="loadCart">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon cart-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-cart-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="cartButton"
                                    data-translation-default="Cart">Cart</span>
                            </div>
                        </a>
                    </li>

                    <li id="meetingsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showMeetingsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon meetings-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="meetingsButton"
                                    data-translation-default="Meetings">Meetings</span>
                            </div>
                        </a>
                    </li>

                    <li id="contactsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showContactsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon contacts-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="contactsButton"
                                    data-translation-default="Contacts">Contacts</span>
                            </div>
                        </a>
                    </li>

                    <li class="demoComparatorSideMenu customcolor">
                        <a id="comparator-side-menu" href="javascript:;" onclick="loadPlugin('debugComparator', this, false)">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon plugin-icon"
                                            src="img/default/comparator_menu.svg" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="pluginButton"
                                    data-translation-default="Debug Comparator">Debug Comparator</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>

                    <li id="adminSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showAdminScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon admin-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="adminButton"
                                    data-translation-default="Admin">Admin</span>
                            </div>
                        </a>
                    </li>

                   <li id="faqsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showFaqsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon faqs-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="faqButton"
                                    data-translation-default="FAQs">FAQs</span>
                            </div>
                        </a>
                    </li>
                    <li id="newsSideMenuIcon" class="customcolor">
                        <a onclick="loadNews(this); return false;">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon news-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="newsButton"
                                    data-translation-default="News">News</span>
                            </div>
                        </a>
                    </li>


                </ul>
                <!-- END SIDEBAR MENU -->
                <script src="js/sidemenufix.js?version=b00000"></script>

            </div>
        </div>
        <!-- END SIDEBAR -->
        <!-- BEGIN CONTENT -->
        <div class="page-content-wrapper">
            <div id="main-div-center" class="page-content view-asset" style="padding-bottom:0px">
                <!-- BEGIN SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                <div class="modal fade" id="portlet-config" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                                <h4 class="modal-title">Modal title</h4>
                            </div>
                            <div class="modal-body">
                                Widget settings form goes here
                                <iframe class="ie9-fix"></iframe>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn blue">Save changes</button>
                                <button type="button" class="btn default" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                    <iframe class="ie9-fix"></iframe>
                </div>
                <!-- /.modal -->
                <!-- END SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                <!-- BEGIN PAGE HEADER-->

                <div class="page-title">
                    <ul class="page-breadcrumb" id="salestoolkit-breadcrumbs"
                        style="white-space: nowrap; display: flex; max-width: 100%; width: 100%;">

                        <li>
                            <!-- <i class="fa icon-home"></i> -->
                            <a href="javascript:;" data-module-action="loadIndex">Home</a>
                            <i class="fa fa-angle-right"></i>
                        </li>

                        <li>
                            <a class="breadsmall" href="javascript:;"></a>
                        </li>

                    </ul>

                </div>


                <!-- END PAGE HEADER-->


                <!-- BEGIN PAGE CONTENT-->
                <div class="row">
                    <div id="main-panel" class="salestoolkit-main-panel">
                        <div class="sidePadding10 portlet light view-asset">
                            <div class="portlet-title">
                                <div class="caption">
                                    <!-- <i class="fa fa-desktop font-blue"></i> -->
                                    <strong><span id="salestoolkit-asset-name"> </span></strong>
                                </div>

                                <div class="actions">

                                    <a id="salestoolkit-asset-info-button"
                                        class="tooltips btn btn-circle info-icon btn-icon-only btn-default font-blue"
                                        data-container="body" data-placement="top" data-html="true"
                                        data-tooltip-translation-key="infoIcon"
                                        data-tooltip-translation-default="Document Information"
                                        data-original-title="Document Information" title="">
                                        <img id="info-icon">
                                    </a>

                                    <a id="salestoolkit-asset-favourite-button"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue"
                                        data-container="body" data-placement="top" data-html="true"
                                        data-tooltip-translation-key="favouritesToggleAdd"
                                        data-tooltip-translation-default="Add to Favourites"
                                        data-original-title="Add to Favourites" title="">
                                        <img id="fav-heart">
                                    </a>

                                    <a id="salestoolkit-asset-cart-button"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue"
                                        href="javascript:;" data-container="body" data-html="true"
                                        data-tooltip-translation-key="cartToggleAdd"
                                        data-tooltip-translation-default="Add to Cart" data-original-title="Add to Cart"
                                        title="">
                                        <img id="cart-trolley">
                                    </a>

                                    <a id="salestoolkit-asset-tag-button"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue"
                                        href="javascript:;" data-container="body" data-original-title="Tag"
                                        data-tooltip-translation-key="tagAssetButton"
                                        data-tooltip-translation-default="Tag" title="">
                                        <img id="tagAssetFull" style="display:none">
                                        <img id="tagAssetEmpty" style="display:none">
                                    </a>

                                    <a id="salestoolkit-asset-related-button"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue"
                                        href="javascript:;" data-container="body" data-original-title="Tag"
                                        data-tooltip-translation-key="relatedAssetButton"
                                        data-tooltip-translation-default="Related Assets" title="">
                                        <img id="relatedAssetFull" style="display:none">
                                        <img id="relatedAssetEmpty" style="display:none">
                                    </a>
                                    <!-- <a id="salestoolkit-related-asset-sort-button"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue"
                                        href="javascript:;" data-container="body" data-original-title="Tag"
                                        data-tooltip-translation-key="relatedAssetsSort"
                                        data-tooltip-translation-default="Sort related assets" title="">
                                        <img id="default-sort-icon" />
                                        <img id="az-sort-icon" style="display:none" />
                                        <img id="za-sort-icon" style="display:none" / >
                                    </a> -->


                                    <a id="salestoolkit-asset-rate-button"
                                        onclick="trackAppClick($('#salestoolkit-asset-rate-button', '#salestoolkit-asset-rate-button', 'trackingRateButton', SalesToolkit.Translation.get('trackingRateButton', 'trackingRateButton')));"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue" href="#rate"
                                        data-original-title="Rate" data-tooltip-translation-key="rateAssetButton"
                                        data-tooltip-translation-default="Rate" data-container="body" data-html="true"
                                        title="" data-toggle="modal" data-bs-toggle="modal" style="display:none">
                                        <img class="rate-icon">
                                        <img class="rate-icon-already-rated">
                                    </a>

                                    <a id="salestoolkit-asset-download-button" style="display:none"
                                        class="tooltips btn btn-circle btn-icon-only btn-default font-blue"
                                        href="javascript:;" data-container="body" data-original-title="Download"
                                        data-tooltip-translation-key="downloadAssetButton"
                                        data-tooltip-translation-default="Download" title="">
                                        <img class="download-icon">
                                    </a>

                                    <span style="display: none;" class="dropdown related-assets-dropdown">
                                        <a class="btn btn-circle btn-default dropdown-toggle" href="javascript:;"
                                            data-toggle="dropdown" data-hover="dropdown"
                                            data-translation-key="relatedAssets" data-translation-case="title"
                                            data-translation-default="Related Assets" data-close-others="true"> Related
                                            Assets </a>

                                        <ul class="dropdown-menu">
                                            <li class="external">
                                                <h3>
                                                    <span class="bold">
                                                        <span data-translation-key="relatedAssets"
                                                            data-translation-default="Related Assets">
                                                            Related Assets
                                                        </span>
                                                    </span>

                                                    <span id="salestoolkit-asset-name-goes-here">
                                                        <span>Asset</span>
                                                    </span>
                                                </h3>
                                                <iframe class="ie9-fix"></iframe>
                                            </li>

                                            <li>
                                                <ul class="dropdown-menu-list scroller"
                                                    id="salestoolkit-related-assets-dropdown" style="height: 275px;"
                                                    data-handle-color="#637283">
                                                </ul> <iframe class="ie9-fix"></iframe>
                                            </li>
                                        </ul>
                                    </span>

                                    <div style="display:none" class="toggle-switch-container">
                                        <div class="toggle-switch switch-vertical">
                                          <input id="toggle-saved-cart" class="no-uniform" type="radio" name="toggle-cart-switch" value="1" checked="checked" />
                                          <label for="toggle-saved-cart"></label>
                                          <input id="toggle-current-cart" class="no-uniform" type="radio" name="toggle-cart-switch" value="2" />
                                          <label data-translation-key="currentCartOption" data-translation-default="Current Cart" for="toggle-current-cart">Current Cart</label>
                                          <span class="toggle-outside">
                                            <span class="toggle-inside"></span>
                                          </span>
                                        </div>
                                      </div>
                                      
                                    <a class="btn btn-circle btn-icon-only btn-default fullscreen" href="javascript:;">
                                        <img class="zoomin-icon" data-original-title="Full Screen"
                                            data-tooltip-translationkey="fullscreen"
                                            data-tooltip-translation-default="Full Screen">

                                        <img class="zoomout-icon" data-original-title="Minimise"
                                            data-tooltip-translationkey="minimise"
                                            data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>


                            </div>

                            <div class="portlet-body view-asset">

                                <div id="breadcrumbsbuttonhide" class="breadcrumbsBackButton">

                                    <a id="previewBackButton" style="display:none" type="button"
                                        onclick="goBack(); return false;">
                                        <img class="backButtonIcon" src="img/default/back_icon.svg" width="20px"
                                            height="20px">
                                        <script>
                                            applyThemeToImage('salestoolkitPortletBackButtonIcon', 'img.backButtonIcon', 'img/default/back_icon.svg');
                                        </script>
                                        <span style="font-weight: 600; font-size: 14px; margin-left: 4px;"></span>
                                    </a>
                                </div>


                                <div class="row">
                                    <div class="col-sm-12" style="overflow: hidden; padding: 0 14px;"
                                        id="iframe-holder">
                                        <!--<iframe id="the_iframe" scrolling="NO" height="768" frameBorder="0" style="-ms-transform-origin: 0 0; transform-origin: 0px 0px 0px;"></iframe>-->
                                        <p id="asset-description-message"></p>
                                        <p id="asset-preview-failure-message">
                                            <span class='hasTranslationKey' data-translation-key="loadingAsset"
                                                data-translation-default="Loading Asset Preview...">Loading Asset
                                                Preview...</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="related-assets-panel" class="col-lg-3 col-md-3" style="display: none;">
                        <div class="portlet light view-asset">
                            <div class="portlet-title">
                                <div class="caption">
                                    <!-- <i class="fa fa-sitemap font-blue"></i> -->
                                    <strong>
                                        <span class='hasTranslationKey' data-translation-key="relatedAssets"
                                            data-translation-default="Related Assets">Related Assets</span>
                                    </strong>
                                </div>
                                <div class="actions" style="display:flex;">
                                    <a href="javascript:;" class="btn btn-circle btn-icon-only btn-default fullscreen">
                                        <img class="zoomin-icon" src="img/default/zoom_icon.svg"
                                            data-original-title="Full Screen" data-tooltip-translationkey="fullscreen"
                                            data-tooltip-translation-default="Full Screen">
                                        <img class="zoomout-icon" src="img/default/zoom_out_icon.svg"
                                            data-original-title="Minimise" data-tooltip-translationkey="minimise"
                                            data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>
                            </div>
                            <div class="portlet-body view-asset">
                                <div id="atheneum-related-assets-view"></div>
                            </div>
                        </div>
                    </div>
                    <div id="tree-view-panel" class="col-lg-3 col-md-3" style="display: block;">
                        <div class="portlet light view-asset">
                            <div class="portlet-title">
                                <div class="caption">
                                    <!-- <i class="fa fa-sitemap font-blue"></i> -->
                                    <strong>
                                        <span class='hasTranslationKey' data-translation-key="treeView"
                                            data-translation-default="Tree View">Tree View</span>
                                    </strong>
                                </div>
                                <div class="actions">
                                    <a href="javascript:;" class="btn btn-circle btn-icon-only btn-default fullscreen">
                                        <img class="zoomin-icon" src="img/default/zoom_icon.svg"
                                            data-original-title="Full Screen" data-tooltip-translationkey="fullscreen"
                                            data-tooltip-translation-default="Full Screen">

                                        <img class="zoomout-icon" src="img/default/zoom_out_icon.svg"
                                            data-original-title="Minimise" data-tooltip-translationkey="minimise"
                                            data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>
                            </div>
                            <div class="portlet-body view-asset">
                                <div id="atheneum-tree-view"></div>
                            </div>
                            <iframe class="ie9-fix"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END PAGE CONTENT-->

            <div class="modal fade" id="rate" tabindex="-1" role="basic" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                            <h4 class="modal-title">
                                <i class="fa fa-star-o font-blue"></i>
                                <span class='hasTranslationKey' data-translation-key="ratingFormTitle"
                                    data-translation-default="Rate Asset">Rate Asset</span>
                            </h4>

                        </div>

                        <div class="modal-body">
                            <div class="portlet-body form">
                                <form role="form">
                                    <div class="form-body">

                                        <style>
                                            #salestoolkit-rate-asset-rating-chooser {
                                                margin-left: 50px;
                                                float: left;
                                                clear: right;
                                                display: block;
                                            }

                                            /* #salestoolkit-rate-asset-rating-chooser .fa-star-o {
                                                margin-top: -2px;
                                            } */

                                            #salestoolkit-rate-asset-rating-chooser input[type=radio] {
                                                display: none !important;
                                                float: right;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser label {
                                                float: right;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser label .fa {
                                                font-size: 24px;
                                                line-height: 24px;
                                                padding: 0px 3px 0px 1px;
                                                text-decoration: none;
                                                color: #5B9BD1;
                                                cursor: pointer;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser label .fa-star {
                                                display: none;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser input[type=radio][value=none]:checked~label:not(:hover) .fa {
                                                color: #ccc;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser label:hover .fa-star-o,
                                            #salestoolkit-rate-asset-rating-chooser label:hover~label .fa-star-o {
                                                display: none;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser label:hover .fa-star,
                                            #salestoolkit-rate-asset-rating-chooser label:hover~label .fa-star {
                                                display: inline;
                                                color: #3175AF;
                                                /* yes important is bad, but fighting selectors is worse */
                                            }

                                            #salestoolkit-rate-asset-rating-chooser input[type=radio]:not([value=none]):checked~label .fa-star-o {
                                                display: none;
                                            }

                                            #salestoolkit-rate-asset-rating-chooser input[type=radio]:not([value=none]):checked~label .fa-star {
                                                display: inline;
                                            }

                                            #salestoolkit-rate-asset-comment {
                                                max-width: 100%;
                                                min-width: 100%;
                                                min-height: 35px;
                                                margin-bottom: 15px;
                                            }

                                            #salestoolkit-rate-asset-rating-label {
                                                float: left;
                                                margin-top: 3px;
                                            }
                                        </style>

                                        <div class="sendpadding" style="overflow: hidden;">
                                            <label id="salestoolkit-rate-asset-rating-label"
                                                data-translation-key="rating"
                                                data-translation-default="Rating">Rating</label>
                                            <div style="float: left; clear: right"
                                                id="salestoolkit-rate-asset-rating-chooser" style="margin-left: 30px;">
                                                <input type="radio" name="salestoolkit-rate-asset-rating"
                                                    id="salestoolkit-rate-asset-rating-none" value="none">
                                                <input type="radio" name="salestoolkit-rate-asset-rating"
                                                    id="salestoolkit-rate-asset-rating-5" value="5" />
                                                <label for="salestoolkit-rate-asset-rating-5"><i
                                                        class="fa fa-star"></i><i class="fa fa-star-o"></i></label>
                                                <input type="radio" name="salestoolkit-rate-asset-rating"
                                                    id="salestoolkit-rate-asset-rating-4" value="4" />
                                                <label for="salestoolkit-rate-asset-rating-4"><i
                                                        class="fa fa-star"></i><i class="fa fa-star-o"></i></label>
                                                <input type="radio" name="salestoolkit-rate-asset-rating"
                                                    id="salestoolkit-rate-asset-rating-3" value="3" />
                                                <label for="salestoolkit-rate-asset-rating-3"><i
                                                        class="fa fa-star"></i><i class="fa fa-star-o"></i></label>
                                                <input type="radio" name="salestoolkit-rate-asset-rating"
                                                    id="salestoolkit-rate-asset-rating-2" value="2" />
                                                <label for="salestoolkit-rate-asset-rating-2"><i
                                                        class="fa fa-star"></i><i class="fa fa-star-o"></i></label>
                                                <input type="radio" name="salestoolkit-rate-asset-rating"
                                                    id="salestoolkit-rate-asset-rating-1" value="1" />
                                                <label for="salestoolkit-rate-asset-rating-1"><i
                                                        class="fa fa-star"></i><i class="fa fa-star-o"></i></label>
                                            </div>
                                        </div>

                                        <div class="sendpadding"
                                            style="margin-top: 20px; float: left; width: 100%; clear: both;">
                                            <label for="salestoolkit-rate-asset-comment"
                                                data-translation-key="ratingComment"
                                                data-translation-default="Comment">Comment</label>
                                            <br />
                                            <textarea class="form-control" placeholder="Leave a Comment (optional)"
                                                data-translation-target="placeholder"
                                                data-translation-key="ratingCommentPlaceholder"
                                                data-translation-default="Leave a Comment (optional)"
                                                id="salestoolkit-rate-asset-comment"></textarea>
                                        </div>

                                    </div>

                                    <div style="text-align: right; margin-top: 15px;">

                                        <button type="button" class="btn default" data-dismiss="modal"
                                            data-translation-key="cancelButton" data-translation-default="Cancel">
                                            Cancel
                                        </button>

                                        <button id="salestoolkit-rate-asset-submit" type="button" class="btn blue"
                                            data-translation-key="rateAssetButton" data-translation-default="Rate">
                                            Rate
                                        </button>
                                    </div>
                                </form>
                            </div>

                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>

            </div>
            <!-- END CONTENT -->
            <!-- BEGIN QUICK SIDEBAR -->
            <!--Cooming Soon...-->
            <!-- END QUICK SIDEBAR -->
        </div>
    </div>
    <!-- END CONTAINER -->
    `;

    //#region Module-level private variables
    let main, tree, related;
    let treeViewLargeCols, relatedAssetsLargeCols;
    let treeViewMediumCols, relatedAssetsMediumCols;
    let treeViewSmallCols, relatedAssetsSmallCols;
    let treeViewLargeColsExtra, treeViewMediumColsExtra, treeViewSmallColsExtra;
    let recenterSummaryObserver = null;
    let fixIframeDimensionsInterval = null;
    let assetHistory = [];
    let salestoolkitCollectionId, salestoolkitAssetId, salestoolkitAsset, salestoolkitPageCameFrom, salestoolkitAssetName;
    let _originalGoBack = null;
    let FAVOURITES_HEART_FULL, FAVOURITES_HEART_EMPTY, SHOPPING_CART_FULL, SHOPPING_CART_EMPTY;
    let TAG_ASSET_EMPTY, TAG_ASSET_FULL, RELATED_ASSET_EMPTY, RELATED_ASSET_FULL;
    let assetTimer = null;
     let assetTracking = null;
     let salestoolkitTreeView = null;
    let assetPreviewAttepmts = 0;
        let submittingTags = false;
    let submittingRelated = false;
    let assetSelector = null;
    let relatedAssetsCache = [];
    let cancelAsync = false;
     let breadcrumbs = null;
     let relatedAssetsDisplay = null;
         let clipboardInterval = null;
         let libraryUpdateCallbacks = null;

    const PDFViewerTracker = {
        currentPage: null,
        viewStartTime: null,
        assetId: null
    };
    //#endregion

        //#region Security & Global APIs

    /**
     * Sets up security-related event listeners to disable context menus, print screen, and various keyboard shortcuts.
     */
    function _setupSecurityListeners() {
        $('body').on('contextmenu.previewAsset', () => false);

        $(document).on('keyup.previewAsset', function(e) {
            if (e.keyCode === 44) { // Print Screen
                _stopPrintScreen();
            }
        });

        $(document).on('keydown.previewAsset', function(e) {
            if (e.keyCode === 44) { // Print Screen
                $('body').hide(); // A bit aggressive, but follows original logic
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            
            // Block Ctrl+P, Ctrl+S, Ctrl+I
            if ((e.ctrlKey || e.metaKey) && ['p', 's', 'i'].includes(e.key.toLowerCase())) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });

        // Attempt to block clipboard access
        clipboardInterval = setInterval(_clearClipboard, 300);
    }

    /**
     * Attempts to prevent print screen by quickly copying empty text to the clipboard.
     */
    function _stopPrintScreen() {
        const inpFld = document.createElement("input");
        inpFld.setAttribute("value", ".");
        inpFld.style.position = 'absolute';
        inpFld.style.left = '-9999px';
        document.body.appendChild(inpFld);
        inpFld.select();
        document.execCommand("copy");
        inpFld.remove();
    }

    /**
     * Attempts to clear clipboard data to prevent copying content.
     */
    function _clearClipboard() {
        try {
            // This is an old method and may not work in modern browsers due to security restrictions.
            if (window.clipboardData && window.clipboardData.setData) {
                 window.clipboardData.setData('text', "");
            }
        } catch (err) {
            // Silently fail as browsers will block this.
        }
    }
    
    /**
     * Shows the Self-Directed Lookup (SDL) modal.
     */
    function _showSDLModal() {
        $("#sdlFormModal").modal('show');
    }

    /**
     * Assigns various global APIs and objects to the window scope.
     * Note: These might be better placed in a general app initialization script.
     */
    function _setupGlobalAPIs() {
        //TODO need to review if these are still needed
        //top.AtheneumSelfDirectedLookup = window.AtheneumSelfDirectedLookup; 
        window.showSDLModal = _showSDLModal;
      window.AtheneumGlobalLookup = AtheneumGlobalLookup; 
        window.CardReader = CardReader;
        window.Html5QrCode = Html5Qrcode;
        window.onFormContactSelect = onFormContactSelect;
        window.iframeFormId = "";
        window.iframeFormElement = {};
    }

    //#endregion


      //#region Related Assets Panel

    /**
     * Initializes the related assets display panel and its event listeners.
     */
    function _setupRelatedAssetsPanel() {
        if (!SalesToolkit.Theme.getBooleanProperty('useRelatedAssets', false)) {
            return;
        }

        relatedAssetsDisplay = Atheneum.UI.ItemGroupDisplay(SalesToolkit, document.getElementById('atheneum-related-assets-view'));
        
        relatedAssetsDisplay.itemTemplate = (
            '<div class="related-asset-item related-asset-browser-{item.type:format(id)} atheneum-item" data-atheneum-item-type="{item.type:format(id)}" data-atheneum-item-id="{item.id:format(id)}">'
            + '<div class="asset-style">'
            + '<div class="collectionIconContainer">'
            + '<div class="collectionIconInnerContainer">'
            + '<div class="atheneum-item-action-btn-holder">'
            + '<a href="javascript:;" data-atheneum-item-action="toggle-info" class="atheneum-item-action info-btn tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" title="Information"><img class="docimg fav-empty-icon" src="img/default/info_icon.svg"></a>'
            + '<a href="javascript:;" data-atheneum-item-action="toggle-favourite" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Add to Favourites"><img class="docimg fav-empty-icon" src="{if (item.inFavourites)}' + FAVOURITES_HEART_FULL + '{else}' + FAVOURITES_HEART_EMPTY + '{end if}" /></a>'
            + '{if (item.shareable)}<a href="javascript:;" data-atheneum-item-action="toggle-cart" class="atheneum-item-action tooltips btn btn-circle btn-icon-only btn-default" data-container="body" data-placement="top" data-html="true" data-original-title="Add to Cart"><img class="docimg" src="{if (item.inCart)}' + SHOPPING_CART_FULL + '{else}' + SHOPPING_CART_EMPTY + '{end if}" /></a>{end if}'
            + '</div>'
            + '<a href="javascript:;" data-atheneum-item-action="view" class="atheneum-item-action" data-container="body"><div class="thumbnail favthumbnail" data-background-image-url="{item.imageUrl:format(url)}?keepRatio=true&shouldCrop=false&width=800&height=450"></div></a>'
            + '<div class="assetThumbnailButtons carticons" style="text-align: center;"><div class="textstarsholder"><div class="caption favcaption"><h4 class="hide-overflow-text-fav text-left atheneum-item-name atheneum-item-action" data-atheneum-item-action="view" style="font-weight: 600;">{item.name}</h4></div></div></div>'
            + '</div></div></div></div>'
        );

        // Attach all event listeners
        relatedAssetsDisplay.on("item-added", _handleRelatedItemAdded);
        relatedAssetsDisplay.on("item-action-view-click", _handleRelatedItemViewClick);
        relatedAssetsDisplay.on("item-action-failure", _handleRelatedItemActionFailure);
        relatedAssetsDisplay.on("item-action-click", (item, action) => $(`[data-atheneum-item-id="${item.id}"] [data-atheneum-item-action="${action}"]`).blur());
        relatedAssetsDisplay.on("info-requested", (item) => showInformationForItem(item));
        
        // Cart and Favourites listeners
        relatedAssetsDisplay.on("item-added-to-favourites", (item) => _updateRelatedItemFavVisual(item, true));
        relatedAssetsDisplay.on("item-removed-from-favourites", (item) => _updateRelatedItemFavVisual(item, false));
        relatedAssetsDisplay.on("item-added-to-cart", (item) => _updateRelatedItemCartVisual(item, true));
        relatedAssetsDisplay.on("item-removed-from-cart", (item) => _updateRelatedItemCartVisual(item, false));
    }

    /**
     * Fetches and displays the related assets in the panel.
     */
    function _populateRelatedAssetsPanel() {
        if (!relatedAssetsDisplay) return;

        const height = $('#main-panel').height();
        $('#atheneum-related-assets-view').css('max-height', (height - 41) + 'px');

        SalesToolkit.Library.getRelatedAssets(salestoolkitAssetId, (relatedAssets) => {
            relatedAssetsDisplay.removeAllItems();
            if (relatedAssets.length === 0) {
                $('#atheneum-related-assets-view').append(`<li>${SalesToolkit.Translation.get('noRelatedAssets', 'No related assets found')}</li>`);
            } else {
                relatedAssets.forEach(asset => {
                    relatedAssetsDisplay.addItem(Atheneum.UI.ItemGroupDisplay.Item.fromAsset(asset, SalesToolkit));
                });
            }
        });
    }
    
    /**
     * Handles post-rendering tasks for a newly added item in the related panel.
     * @param {object} item - The item that was added.
     */
    function _handleRelatedItemAdded(item) {
        _updateRelatedItemFavVisual(item, SalesToolkit.Favourites.assetIds.includes(item.id));
        _updateRelatedItemCartVisual(item, SalesToolkit.Cart.containsAsset(item.id));

        const itemElement = $(`#atheneum-related-assets-view .atheneum-item[data-atheneum-item-id="${item.id}"]`);
        const infoIconElement = itemElement.find('.info-btn img');
        
        if (infoIconElement.length) {
            // Logic to set correct info icon based on priority/manual relation
            // This can be refactored further if needed
        }

        const thumbnailElement = itemElement.find('.thumbnail');
        const bgImageURL = thumbnailElement.data('background-image-url');
        if (bgImageURL) {
            addUrlToRewriteQueue(bgImageURL, (rewrittenURL) => {
                if (rewrittenURL) {
                    thumbnailElement.css('background-image', `url('${rewrittenURL}')`).css('opacity', 1);
                }
            });
        }
    }

    /**
     * Handles the click on a 'view' action for a related item.
     * @param {object} item - The item being viewed.
     */
    function _handleRelatedItemViewClick(item) {
        trackAppClick($('.related-asset-item'), `.related-asset-item[data-atheneum-item-id='${item.id}']`, 'trackingRelatedItemClick', SalesToolkit.Translation.get('trackingRelatedItemClick', 'trackingRelatedItemClick'));

        if (item.type === "asset" && !SalesToolkit.Library.assets[item.id].canPreview) {
            return false;
        }

        if (item.type === "asset" && SalesToolkit.Pages.PreviewAssetPage.url) {
            _loadAsset(item.id);
        } else if (item.type === "collection" && SalesToolkit.Pages.ExploreCollectionPage.url) {
           loadIndexScreen(false, false, item.id);
        }
        return false;
    }

    /**
     * Handles API failures for related item actions, especially for offline mode.
     * @param {object} item - The item.
     * @param {string} action - The action that failed (e.g., 'add-to-favourites').
     * @param {object} details - Failure details from the API call.
     */
    function _handleRelatedItemActionFailure(item, action, details) {
        if (!Atheneum.Callbacks.isOffline(details.reason, details.httpStatus, details.errorCode)) return;

        const actionMap = {
            'add-to-favourites': { notification: 'notificationFavouritesAdded', event: 'item-added-to-favourites' },
            'remove-from-favourites': { notification: 'notificationFavouritesRemoved', event: 'item-removed-from-favourites' },
            'add-to-cart': { notification: 'notificationCartAdded', event: 'item-added-to-cart' },
            'remove-from-cart': { notification: 'notificationCartRemoved', event: 'item-removed-from-cart' }
        };

        if (actionMap[action]) {
            const { notification, event } = actionMap[action];
            const notificationBody = SalesToolkit.Translation.getFormatted(notification, '', [item.name]);
            SalesToolkit.UI.Notifications.showCustomNotification("favourites", notificationBody);
            relatedAssetsDisplay.trigger(event, item);
        }
    }

    /**
     * Updates the visual state of a favourite button for a related asset.
     * @param {object} item - The asset item.
     * @param {boolean} isFavourite - Whether the item is now a favourite.
     */
    function _updateRelatedItemFavVisual(item, isFavourite) {
        const favButton = $(`[data-atheneum-item-id="${item.id}"] [data-atheneum-item-action="toggle-favourite"]`);
        if (!favButton.length) return;

        const newTitle = isFavourite ? SalesToolkit.Translation.get('favouritesToggleRemove', 'Remove from Favourites') : SalesToolkit.Translation.get('favouritesToggleAdd', 'Add to Favourites');
        favButton.attr("title", newTitle).toggleClass("already-clicked", isFavourite);
        favButton.find("img").attr("src", isFavourite ? FAVOURITES_HEART_FULL : FAVOURITES_HEART_EMPTY);
    }
    
    /**
     * Updates the visual state of a cart button for a related asset.
     * @param {object} item - The asset item.
     * @param {boolean} inCart - Whether the item is now in the cart.
     */
    function _updateRelatedItemCartVisual(item, inCart) {
        const cartButton = $(`[data-atheneum-item-id="${item.id}"] [data-atheneum-item-action="toggle-cart"]`);
        if (!cartButton.length) return;

        const newTitle = inCart ? SalesToolkit.Translation.get('cartToggleRemove', 'Remove from Cart') : SalesToolkit.Translation.get('cartToggleAdd', 'Add to Cart');
        cartButton.attr("title", newTitle).toggleClass("already-clicked", inCart);
        cartButton.find("img").attr("src", inCart ? SHOPPING_CART_FULL : SHOPPING_CART_EMPTY);
        SalesToolkit.UI.Cart.updateMenuCartBadge();
    }

    //#endregion

     //#region Breadcrumbs, Info & Rating

    /**
     * Renders the full breadcrumb trail for the current asset.
     */
    function _renderBreadcrumbs() {
        if (!breadcrumbs) return;
        breadcrumbs.innerHTML = "";
        
        _addRootBreadcrumb('Home', 'index.html?breadcrumb=true&loadHome=true');

        const assetPath = _getAssetPath();
        assetPath.reverse().forEach(collection => {
            if (!collection) return;

            // Don't show the breadcrumb for the top-level home folder
            if (SalesToolkit.getHomeCollectionID() && SalesToolkit.getHomeCollectionID() === collection.id) {
                return;
            }
            
            // Additional logic to hide breadcrumbs not descending from the home collection
            if (SalesToolkit.getHomeCollectionID()) {
                let currentParentId = collection.containedBy;
                let isInHomeTree = false;
                while (currentParentId != null) {
                    if (currentParentId === SalesToolkit.getHomeCollectionID()) {
                        isInHomeTree = true;
                        break;
                    }
                    const parent = SalesToolkit.Library.collections[currentParentId];
                    currentParentId = parent ? parent.containedBy : null;
                }
                if (!isInHomeTree) return;
            }
            
            _addBreadcrumb(collection.name, `index.html?breadcrumb=true&collectionId=${collection.id}`);
        });

        // Add final asset breadcrumb
        _addBreadcrumb(salestoolkitAssetName);
    }

      /**
     * Helper to add the root (home) breadcrumb.
     * @param {string} text - The display text.
     * @param {string} link - The original URL (now unused, kept for compatibility).
     * @param {string} [icon='fa-home'] - The Font Awesome icon class.
     */
    function _addRootBreadcrumb(text, link, icon = 'fa-home') {
        const translationKey = { Home: 'homeButton', Library: 'libraryButton' }[text] || text;
        const translatedText = SalesToolkit.Translation.get(translationKey, text);
        const li = document.createElement('li');
        // Replaced href with data-module-action
        li.innerHTML = `<i class="fa ${icon}"></i> <a data-module-action="loadIndexFromBreadcrumb" href="javascript:;" data-translation-rendered="true" data-translation-key="${translationKey}" data-translation-default="${text}">${translatedText}</a>`;
        breadcrumbs.appendChild(li);
    }


      /**
     * Helper to add a subsequent breadcrumb.
     * @param {string} text - The display text.
     * @param {string} [link] - The original URL, used to extract the collectionId.
     */
    function _addBreadcrumb(text, link) {
        const li = document.createElement('li');
        if (link) {
            // Extract collectionId from the old link format to use in the data attribute
            const collectionId = new URLSearchParams(link.split('?')[1]).get('collectionId');
            li.innerHTML = `<i class="fa fa-angle-right"></i> <a class="breadsmall" href="javascript:;" data-module-action="loadIndexFromBreadcrumb" data-collection-id="${collectionId}">${text}</a>`;
        } else {
            // Non-clickable breadcrumb for the current item
            li.innerHTML = `<i class="fa fa-angle-right"></i> <span>${text}</span>`;
        }
        breadcrumbs.appendChild(li);
    }


    /**
     * Gets the hierarchical path of collections for the current asset.
     * @returns {Array<object>} - An array of collection objects from parent to root.
     */
    function _getAssetPath() {
        const path = [];
        let currentItem = SalesToolkit.Library.assets[salestoolkitAssetId];
        while (currentItem && currentItem.containedBy) {
            currentItem = SalesToolkit.Library.collections[currentItem.containedBy];
            if (currentItem) {
                path.push(currentItem);
            } else {
                break;
            }
        }
        return path;
    }

    /**
     * Handles the submission of an asset rating.
     */
    function _handleRateSubmit() {
        const rating = $('[name="salestoolkit-rate-asset-rating"]:checked').val();
        const comment = $('#salestoolkit-rate-asset-comment').val() || undefined;
        const oldRatingNumber = SalesToolkit.User.getAssetRatingNumber(salestoolkitAssetId);

        SalesToolkit.User.rateAsset(salestoolkitAssetId, rating, comment, {
            success: function() {
                const asset = SalesToolkit.Library.assets[salestoolkitAssetId];
                if (oldRatingNumber) {
                    asset.ratingTotal += (rating - oldRatingNumber);
                } else {
                    asset.ratingCount = (asset.ratingCount || 0) + 1;
                    asset.ratingTotal = (asset.ratingTotal || 0) + Number(rating);
                }
                asset.avgRating = asset.ratingTotal / asset.ratingCount;
                
                $('#rate').modal('hide');
                SalesToolkit.UI.Notifications.showCustomNotification("info", SalesToolkit.Translation.get('ratingSuccess', 'Rating submitted'));

                // Persist updated collection data
                const topLevelCollectionId = SalesToolkit.Library.__getAncestorId(asset.containedBy);
                if (topLevelCollectionId) {
                    setTimeout(() => {
                        const topLevelCollection = SalesToolkit.Library.collections[topLevelCollectionId];
                        if (topLevelCollection) {
                            SalesToolkit.Library.__saveCollectionToStorageAsync(topLevelCollection);
                        }
                    }, 500);
                }
            },
            failure: function() {
                SalesToolkit.UI.Notifications.showCustomNotification("info", SalesToolkit.Translation.get('ratingFail', 'Rating failed, please try again later'));
            }
        });
    }

    //#endregion
    
     //#region Tagging & Related Assets

    /**
     * Populates and shows the tagging modal.
     */
    function _showTagModal() {
        const tagButton = document.getElementById('salestoolkit-asset-tag-button');
        if (tagButton.classList.contains('disabled')) return;
        
        tagButton.blur();
        const tagHolder = $('#tagHolder');
        tagHolder.empty();
        let selectedTagOptions = [];

        let tags = [...SalesToolkit.Admin.tags]; // Create a copy to avoid sorting the original
        tags.sort((a, b) => {
            if (a.automatic && b.automatic) return a.order - b.order;
            if (a.automatic) return 1;
            if (b.automatic) return -1;
            return 0; // Ensure a value is always returned
        });

        tags.forEach(tag => {
            if (!tag.visible && (tag.appliedVisible === false || tag.appliedVisible === undefined)) return;

            let optionsHtml = "";
            tag.options.sort((a, b) => (a.label + "").localeCompare(b.label + ""));
            
            tag.options.forEach(option => {
                const value = tag.id + option.name + option.label;
                if (option.autoAssetIds?.includes(salestoolkitAssetId)) {
                    optionsHtml += `<option class='automaticTag' data-option-auto='true' data-option-name='${option.name}' data-tag-id='${tag.id}' selected value='${value}'>${option.label}</option>`;
                    selectedTagOptions.push(value);
                } else if (option.assetIds?.includes(salestoolkitAssetId)) {
                    optionsHtml += `<option data-option-name='${option.name}' data-tag-id='${tag.id}' selected value='${value}'>${option.label}</option>`;
                    selectedTagOptions.push(value);
                } else {
                    if (!tag.visible && tag.unAppliedVisible === false) return;
                    optionsHtml += `<option data-option-name='${option.name}' data-tag-id='${tag.id}' value='${value}'>${option.label}</option>`;
                }
            });

            if(optionsHtml) {
                 tagHolder.append(`<optgroup label='${tag.label}'>${optionsHtml}</optgroup>`);
            }
        });

        $('.search-input').val('');

        if (tagHolder.data('multiselect')) {
            tagHolder.multiselect('destroy');
        }

        tagHolder.multiSelect({
            selectableHeader: `<input type='text' class='profile-input search-input' autocomplete='off' placeholder='${SalesToolkit.Translation.get('searchTags', 'Search Tags')}'>`,
            selectionHeader: `<input type='text' class='profile-input search-input' autocomplete='off' placeholder='${SalesToolkit.Translation.get('searchTags', 'Search Tags')}'>`,
            afterInit: function(ms) {
                const that = this;
                that.qs1 = that.$selectableUl.prev().quicksearch('#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)');
                that.qs2 = that.$selectionUl.prev().quicksearch('#' + that.$container.attr('id') + ' .ms-elem-selection.ms-selected');
            },
            afterSelect: function() { this.qs1.cache(); this.qs2.cache(); },
            afterDeselect: function() { this.qs1.cache(); this.qs2.cache(); }
        });

        tagHolder.multiSelect('select', selectedTagOptions);
        $('#ms-tagHolder .ms-list').css({ 'height': '60vh', 'max-height': '60vh' });

        trackAppClick($('#tagDocumentModal'), '#tagDocumentModal', 'trackingPreviewPageTagOpen', SalesToolkit.Translation.get('trackingPreviewPageTagOpen', 'trackingPreviewPageTagOpen'));
        $('#tagDocumentModal').modal('show');
    }

    /**
     * Submits the selected tags for the current asset.
     */
    function _submitTags() {
        if (submittingTags) return;
        submittingTags = true;

        SalesToolkit.UI.Notifications.showCustomNotification("admin", SalesToolkit.Translation.get('assetTagSubmitting', 'Submitting tags.'));

        const selections = $('#ms-tagHolder .ms-selection .ms-selected');
        const results = {};
        selections.each(function() {
            const selection = $(this);
            const tagId = selection.data('tag-id');
            const value = selection.data('option-name');
            if (!results[tagId]) {
                results[tagId] = [];
            }
            results[tagId].push(value);
        });

        for(const tagId in results) {
            results[tagId] = results[tagId].join(',');
        }

        trackAppClick($('#tagDocumentModal'), '#tagDocumentModal', 'trackingPreviewPageTagSubmit', SalesToolkit.Translation.get('trackingPreviewPageTagSubmit', 'trackingPreviewPageTagSubmit'));

        SalesToolkit.Admin.assignTagsToAsset(salestoolkitAssetId, results, {
            success: function() {
                SalesToolkit.UI.Notifications.showCustomNotification("admin", SalesToolkit.Translation.get('assetTaggedSuccessfully', 'Tags have been applied successfully.'));
                $('#tagDocumentModal').modal('hide');
                submittingTags = false;
                _updateTagIcon();
                forceLibraryUpdate = true; // Assumes global forceLibraryUpdate
                SalesToolkit.Library.update(libraryUpdateCallbacks); // Assumes global libraryUpdateCallbacks
            },
            failure: function(reason, httpStatus, errorCode) {
                submittingTags = false;
                const errorName = SalesToolkit.API.ErrorCodes.getName(errorCode);
                const notificationBody = SalesToolkit.Translation.get('error0' + errorCode.toString(16), errorName);
                SalesToolkit.UI.Notifications.showCustomNotification("admin", notificationBody);
                _updateTagIcon();
            }
        });
    }

    /**
     * Prepares and shows the related assets modal.
     */
    function _showRelatedAssetsModal() {
        trackAppClick($('#relatedDocumentModal'), '#relatedDocumentModal', 'trackingRelatedAssetsEditorOpen', SalesToolkit.Translation.get('trackingRelatedAssetsEditorOpen', 'trackingRelatedAssetsEditorOpen'));
        
        relatedAssetsCache = Object.values(SalesToolkit.Library.assets).filter(x => SalesToolkit.User.canSee(x));
        const collection = SalesToolkit.Library.collections[salestoolkitAsset.containedBy];
        if (collection) {
            const siblingIds = collection.assets?.map(x => x.id) || [];
            relatedAssetsCache = relatedAssetsCache.filter(x => !siblingIds.includes(x.id));
        }
        
        _buildAssetSelector();
        $('#relatedDocumentModal').modal('show');
    }
    
    /**
     * Builds and configures the AssetSelector component.
     */
    function _buildAssetSelector() {
        SalesToolkit.Admin.getRelatedAssetIds(salestoolkitAssetId, function(relatedAssetIds) {
            if (assetSelector == null) {
                const searchableEntries = JSON.parse(SalesToolkit.Translation.get('searchableEntries', '[]'));
                assetSelector = new AssetSelector(relatedAssetsCache, document.getElementById('relatedHolder'), SalesToolkit.Theme.getIntegerProperty('resultPerPageRelatedPopup', 10), searchableEntries);
            }
            assetSelector.clearSearch();
            assetSelector.showFilters();
            assetSelector.setSelectedItemsByIds(relatedAssetIds);
        });
    }

    /**
     * Submits the selected related assets.
     */
    function _submitRelatedAssets() {
        if (submittingRelated) return;
        submittingRelated = true;
        
        assetSelector.cancelPopups();
        
        const selectedAssets = assetSelector?.selectedItems;
        const reciprocateAdds = $('#related-reciprocate-adds').prop('checked');
        const reciprocateRemovals = $('#related-reciprocate-removals').prop('checked');
        const reciprocateExisting = $('#related-reciprocate-existing').prop('checked');

        trackAppClick($('#relatedDocumentModal'), '#relatedDocumentModal', 'trackingRelatedAssetsEditorSubmit', SalesToolkit.Translation.get('trackingRelatedAssetsEditorSubmit', 'trackingRelatedAssetsEditorSubmit'));

        const finalise = (relatedAssetIds) => {
            _updateRelatedIcon(relatedAssetIds);
            _populateRelatedAssetsPanel(); // Assumes global populateRelatedAssetsPanel
        };

        SalesToolkit.Admin.setRelatedAssets(salestoolkitAssetId, selectedAssets, reciprocateAdds, reciprocateRemovals, reciprocateExisting, {
            success: function(relatedAssetIds) {
                SalesToolkit.UI.Notifications.showCustomNotification("admin", SalesToolkit.Translation.get('assetsRelatedSuccessfully', 'Assets have been set as related successfully.'));
                $('#relatedDocumentModal').modal('hide');
                submittingRelated = false;
                finalise(relatedAssetIds);
            },
            failure: function(reason, httpStatus, errorCode) {
                submittingRelated = false;
                const errorName = SalesToolkit.API.ErrorCodes.getName(errorCode);
                const notificationBody = SalesToolkit.Translation.get('error0' + errorCode.toString(16), errorName);
                SalesToolkit.UI.Notifications.showCustomNotification("admin", notificationBody);
                SalesToolkit.Admin.getRelatedAssetIds(salestoolkitAssetId, finalise);
            }
        });
    }


    /**
     * Cancels the related asset build process. Makes itself globally available.
     */
    function _cancelRelatedBuild() {
        if (assetSelector) {
            assetSelector.cancelPopups();
            assetSelector.clearSearch();
        }
        cancelAsync = true; // This flag is used to stop async operations if any are running
    }
    //#endregion

    //#region UI & Icon Management
    /**
     * Initializes icon path variables and handles URL rewriting for cross-platform compatibility.
     */
    function _initializeIcons() {
        FAVOURITES_HEART_FULL = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconRemoveFromFavourites', 'img/default/favourites_full_icon.svg');
        FAVOURITES_HEART_EMPTY = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconAddToFavourites', 'img/default/favourites_empty_icon_sml.svg');
        SHOPPING_CART_FULL = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconRemoveFromCart', 'img/default/shopping_cart_full_new.svg');
        SHOPPING_CART_EMPTY = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconAddToCart', 'img/default/shopping_cart_new_blue.svg');
        TAG_ASSET_EMPTY = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconTagAssetEmpty', 'img/default/preview-icon-tag-asset_empty.svg');
        TAG_ASSET_FULL = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconTagAssetFull', 'img/default/preview-icon-tag-asset_full.svg');
        RELATED_ASSET_EMPTY = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconRelatedAssetEmpty', 'img/default/preview-icon-related-asset_empty.svg');
        RELATED_ASSET_FULL = SalesToolkit.Theme.getStringProperty('salestoolkitPreviewIconRelatedAssetFull', 'img/default/preview-icon-related-asset_full.svg');

        if (SalesToolkit.CrossPlatform.enabled) {
            const iconsToRewrite = [
                { el: '#fav-heart', empty: FAVOURITES_HEART_EMPTY, full: FAVOURITES_HEART_FULL, inCollection: SalesToolkit.Favourites.assetIds.some(x => x === salestoolkitAssetId) },
                { el: '#cart-trolley', empty: SHOPPING_CART_EMPTY, full: SHOPPING_CART_FULL, inCollection: SalesToolkit.Cart.assetIds.some(x => x === salestoolkitAssetId) },
                { el: '#tagAssetEmpty', empty: TAG_ASSET_EMPTY },
                { el: '#tagAssetFull', full: TAG_ASSET_FULL },
                { el: '#relatedAssetEmpty', empty: RELATED_ASSET_EMPTY },
                { el: '#relatedAssetFull', full: RELATED_ASSET_FULL }
            ];

            iconsToRewrite.forEach(icon => {
                const processIcon = (path, isFull) => {
                    if (!path) return;
                    if (!SalesToolkit.CrossPlatform.urlRewriteCache[path]) {
                        addUrlToRewriteQueue(path, function (rewrittenURL) {
                            if (isFull === undefined || icon.inCollection === isFull) $(icon.el).attr('src', rewrittenURL);
                            window[isFull ? icon.fullVar : icon.emptyVar] = rewrittenURL;
                        });
                    }
                };
                processIcon(icon.full, true);
                processIcon(icon.empty, false);
            });

        } else {
            $('#tagAssetFull').attr('src', SalesToolkit.CrossPlatform.rewriteURL(TAG_ASSET_FULL));
            $('#tagAssetEmpty').attr('src', SalesToolkit.CrossPlatform.rewriteURL(TAG_ASSET_EMPTY));
            $('#relatedAssetFull').attr('src', SalesToolkit.CrossPlatform.rewriteURL(RELATED_ASSET_FULL));
            $('#relatedAssetEmpty').attr('src', SalesToolkit.CrossPlatform.rewriteURL(RELATED_ASSET_EMPTY));
        }
    }

    /**
     * Updates the tag icon based on whether the asset has any tags.
     */
    function _updateTagIcon() {
        let full = false;
        for (let i = 0; i < SalesToolkit.Admin.tags?.length; i++) {
            let tag = SalesToolkit.Admin.tags[i];
            for (let j = 0; j < tag.options.length; j++) {
                let option = tag.options[j];
                if (option.assetIds?.indexOf(salestoolkitAssetId) >= 0) {
                    full = true;
                    break;
                }
            }
            if (full) break;
        }

        if (full) {
            $('#tagAssetEmpty').hide();
            $('#tagAssetFull').show();
        } else {
            $('#tagAssetFull').hide();
            $('#tagAssetEmpty').show();
        }
    }

    /**
     * Updates the related assets icon based on whether the asset has related items.
     * @param {string[]} relatedAssetIds - An array of related asset IDs.
     */
    function _updateRelatedIcon(relatedAssetIds) {
        let full = relatedAssetIds.length > 0;
        if (full) {
            $('#relatedAssetEmpty').hide();
            $('#relatedAssetFull').show();
        } else {
            $('#relatedAssetFull').hide();
            $('#relatedAssetEmpty').show();
        }
    }
    //#endregion

    //#region Asset Timers
    /**
     * Handles the completion of the asset-specific view timer.
     * @param {boolean} [ignoreLastFinished=false] - If true, doesn't store the finish time in localStorage.
     */
    function _assetTimerFinished(ignoreLastFinished = false) {
        SalesToolkit.Tracking.finish("asset", salestoolkitAssetId);
        const overlay = vPopup.create({
            title: SalesToolkit.Translation.getOrGetThemeKey('noDetailsTimerTitle', 'Attention'),
            message: SalesToolkit.Translation.getOrGetThemeKey('noDetailsTimerMessage', 'To keep reading please start a session by filling in your details.'),
            buttons: [{
                action: "CANCEL",
                text: SalesToolkit.Translation.getOrGetThemeKey('noDetailsTimerTitleCancel', 'Cancel'),
                callback: function () {
                    if (!ignoreLastFinished)
                        localStorage['assetTimerFinished_' + salestoolkitAssetId] = new Date().getTime();
                    _goBack();
                },
                dismiss: true,
                buttonClass: "btn default btn-secondary timerButton"
            }, {
                action: "OK",
                text: SalesToolkit.Translation.getOrGetThemeKey('noDetailsTimerTitleOK', 'OK'),
                callback: function () {
                    const form = _findUserDetailsForm();
                    if (!form) {
                        const title = SalesToolkit.Translation.get('noDetailsTimerNoFormTitle', "Error.");
                        const message = SalesToolkit.Translation.get('noDetailsTimerNoFormMessage', "No form setup for user details submission.");
                        localStorage["notificationsToShow"] = JSON.stringify([{ body: message, title: title, type: "info" }]);
                        _goBack();
                    } else {
                        if (!ignoreLastFinished)
                            localStorage['assetTimerFinished_' + salestoolkitAssetId] = new Date().getTime();
                        let urlParams = _getUrlVars();
                        urlParams.fromAsset = salestoolkitAssetId;
                        loadForm(form[0].id, urlParams); // Assumes global loadForm exists
                    }
                },
                dismiss: true,
                buttonClass: "btn salestoolkit-blue btn-primary timerButton"
            }]
        });
        $(overlay).attr('style', 'background: ' + SalesToolkit.Theme.getStringProperty('noDetailsTimerBackground', 'rgba(0,0,0,0.95)'));
    }

    /**
     * Handles the completion of the global asset view timer.
     */
    function _globalAssetTimerFinished() {
        const overlay = vPopup.create({
            title: SalesToolkit.Translation.getOrGetThemeKey('noDetailsGlobalTimerTitle', 'Attention'),
            message: SalesToolkit.Translation.getOrGetThemeKey('noDetailsGlobalTimerMessage', 'All assets are now locked. To keep reading please start a session by filling in your details.'),
            buttons: [{
                action: "CANCEL",
                text: SalesToolkit.Translation.getOrGetThemeKey('noDetailsTimerTitleCancel', 'Cancel'),
                callback: function () { _goBack(); },
                dismiss: true,
                buttonClass: "btn default btn-secondary timerButton"
            }, {
                action: "OK",
                text: SalesToolkit.Translation.getOrGetThemeKey('noDetailsTimerTitleOK', 'OK'),
                callback: function () {
                    const form = _findUserDetailsForm();
                    if (!form) {
                        const title = SalesToolkit.Translation.get('noDetailsTimerNoFormTitle', "Error.");
                        const message = SalesToolkit.Translation.get('noDetailsTimerNoFormMessage', "No form setup for user details submission.");
                        localStorage["notificationsToShow"] = JSON.stringify([{ body: message, title: title, type: "info" }]);
                        _goBack();
                    } else {
                        let urlParams = _getUrlVars();
                        urlParams.fromAsset = salestoolkitAssetId;
                        loadForm(form[0].id, urlParams); // Assumes global loadForm exists
                    }
                },
                dismiss: true,
                buttonClass: "btn salestoolkit-blue btn-primary timerButton"
            }]
        });
        $(overlay).attr('style', 'background: ' + SalesToolkit.Theme.getStringProperty('noDetailsTimerBackground', 'rgba(0,0,0,0.95)'));
    }

    /**
     * Starts the asset view timer.
     */
    function _startAssetTimer() {
        let noDetailsTimer = SalesToolkit.Theme.getIntegerProperty('noDetailsPreviewTimer_' + salestoolkitAssetId, SalesToolkit.Theme.getIntegerProperty('noDetailsPreviewTimer', 60000));
        let timerDelay = noDetailsTimer + 1000;
        assetTimer = setTimeout(_assetTimerFinished, timerDelay);
    }
    //#endregion

    //#region Asset & Preview Setup
     /**
     * Shows the asset preview, handling different content types like iframes, PDFs, and videos.
     */
    function _showAssetPreview() {
        if (salestoolkitAsset.canPreview) {
            SalesToolkit.Library.getAssetPreview(salestoolkitAssetId, {
                success: function (connection) {
                    if (typeof SalesToolkit.Forms.userDetails !== 'object' && SalesToolkit.Theme.getBooleanProperty('C' + salestoolkitAssetId, SalesToolkit.Theme.getBooleanProperty('assetPreviewNeedsUserDetails', false))) {

                        const visit = SalesToolkit.User.getVisit();

                        if (visit != null && SalesToolkit.Theme.getIntegerProperty('globalAssetsBlockerTimer', -1) > 0 && (new Date().getTime() - visit) >= SalesToolkit.Theme.getIntegerProperty('globalAssetsBlockerTimer', -1)) {
                            _globalAssetTimerFinished(true);
                            return;
                        }
                        let lastTimerFinished = localStorage['assetTimerFinished_' + salestoolkitAssetId];
                        if (lastTimerFinished == 'undefined')
                            lastTimerFinished = undefined;
                        if (lastTimerFinished) {
                            const ms = new Date().getTime() - lastTimerFinished;

                            const cooldown = SalesToolkit.Theme.getIntegerProperty('minimumCooldownForAssetNeedsDetailsPopup_' + salestoolkitAssetId, SalesToolkit.Theme.getIntegerProperty('minimumCooldownForAssetNeedsDetailsPopup', -1));
                            if (cooldown < 0 || ms < cooldown) {
                                _assetTimerFinished(true);
                            } else {
                                delete localStorage['assetTimerFinished_' + salestoolkitAssetId];
                                _startAssetTimer();
                            }
                        } else {
                            _startAssetTimer();
                        }

                    }

                    assetPreviewAttepmts = 0;
                    if (connection.responseText.startsWith("http")) {
                        let useIframe = SalesToolkit.Theme.getBooleanProperty('useIframeForAssetUrls', false);
                        if (useIframe) {
                            console.log("Loading in asset url in iframe");
                            document.getElementById('iframe-holder').innerHTML = "<iframe src=\"\"></iframe>";
                            assetTracking = SalesToolkit.Tracking.startTrackingAssetView(salestoolkitAssetId);
                            const iframe = document.querySelector('#iframe-holder iframe')
                            if (iframe) {
                                iframe.setAttribute("scrolling", "NO");
                                iframe.setAttribute("frameBorder", "0");
                                iframe.setAttribute("style", "-ms-transform-origin: 0 0; transform-origin: 0px 0px 0px;");
                                $(window).resize();
                                iframe.src = connection.responseText;
                            }

                            if (SalesToolkit.Theme.getBooleanProperty('autoFullScreenAsset' + salestoolkitAssetId, false)) {
                                setTimeout(function () {
                                    $('#main-panel a.fullscreen').click();
                                }, 200);
                            }
                        } else {
                            console.log("Loading in asset url in window");
                            document.getElementById('iframe-holder').innerHTML = "";
                            window.location = connection.responseText;
                        }

                        $('.assetSummary').remove();
                        if (typeof salestoolkitAsset.summary == 'string' && salestoolkitAsset.summary.length > 0 && SalesToolkit.Theme.getBooleanProperty('showAssetSummary', false)) {
                            $('#breadcrumbsbuttonhide').after('<div style="position:relative" class="assetSummary">' + salestoolkitAsset.summary + '</div>');
                            setTimeout(_recenterSummary, 300);
                        }

                        _setupGalleryNav();
                        return;
                    }
                    let loadedNatively = false;
                    if (SalesToolkit.CrossPlatform.enabled && SalesToolkit.Theme.getCollectionBooleanProperty(salestoolkitCollectionId, "loadPdfPreviewsNatively", false)) {
                        const pdfIframeOffset = $('#iframe-holder').offset();
                        try {
                            pdfIframeOffset.left += parseInt($('#iframe-holder').css('padding-left')) + parseInt($('#iframe-holder').css('margin-left'));
                            pdfIframeOffset.top += parseInt($('#iframe-holder').css('padding-top')) + parseInt($('#iframe-holder').css('margin-top'));
                        } catch (err) {}
                        loadedNatively = SalesToolkit.CrossPlatform.loadNativePDFViewer(salestoolkitAssetId, pdfIframeOffset, $('#iframe-holder').width(), $('#iframe-holder').height());
                    }

                    if (!loadedNatively) {
                        document.getElementById('iframe-holder').innerHTML = connection.responseText;
                        if (connection.hasOwnProperty('script')) {
                            document.getElementById('iframe-holder').appendChild(connection.script);
                        }
                    }

                    assetTracking = SalesToolkit.Tracking.startTrackingAssetView(salestoolkitAssetId);

                    $('video').on('ended', function () {
                        _showCertificateFormIfExists();
                    });

                    const iframe = document.querySelector('#iframe-holder iframe')
                    if (iframe) {
                        if ($(iframe).attr('scrolling') == 'YES') {
                            iframe.setAttribute("scrolling", "YES");
                        } else {
                            iframe.setAttribute("scrolling", "NO");
                        }
                        iframe.setAttribute("frameBorder", "0");
                        iframe.setAttribute("style", "-ms-transform-origin: 0 0; transform-origin: 0px 0px 0px;");
                        $(window).resize();
                    }

                    if (SalesToolkit.Theme.getBooleanProperty('autoFullScreenAsset' + salestoolkitAssetId, false)) {
                        setTimeout(function () {
                            $('#main-panel a.fullscreen').click();
                        }, 200);
                    }

                    $('.assetSummary').remove();
                    if (typeof salestoolkitAsset.summary == 'string' && salestoolkitAsset.summary.length > 0 && SalesToolkit.Theme.getBooleanProperty('showAssetSummary', false)) {
                        $('#breadcrumbsbuttonhide').after('<div style="position:relative" class="assetSummary">' + salestoolkitAsset.summary + '</div>');
                        setTimeout(_recenterSummary, 300);
                    }
                    _setupGalleryNav();
                },
                failure: function (connection) {
                    if (assetPreviewAttepmts < 3) {
                        setTimeout(() => {
                            assetPreviewAttepmts++;
                            _showAssetPreview();
                        }, 1000);
                    } else {
                        assetPreviewAttepmts = 0;
                        document.getElementById('iframe-holder').innerHTML = SalesToolkit.Translation.get("errorPreviewAssetHtml", "<p>An error occurred trying to preview this asset</p>");
                    }
                }
            });
        } else {
            document.getElementById('iframe-holder').innerHTML = SalesToolkit.Translation.get("assetDisallowsPreviewHtml", "<p>Asset can't be previewed</p>");
        }
    }

    /**
     * Sets up the gallery navigation arrows if enabled.
     */
    function _setupGalleryNav() {
        let iframeHolder = $('#iframe-holder');
        if (SalesToolkit.Theme.getBooleanProperty('useGalleryNav', false)) {
            iframeHolder.toggleClass('galleryMode', true);
            $('#galleryLeftNav').remove();
            $('#galleryRightNav').remove();
            iframeHolder.prepend("<div id='galleryNavRight' onclick='previewAssetModule.navGalleryRight()' class='galleryNav'>&#8250;</div>");
            iframeHolder.prepend("<div id='galleryNavLeft' onclick='previewAssetModule.navGalleryLeft()' class='galleryNav'>&#8249;</div>");
        } else {
            iframeHolder.toggleClass('galleryMode', false);
        }
    }

    /**
     * Navigates to the previous asset in the gallery.
     */
    function _navGalleryLeft() {
        let collection = SalesToolkit.Library.collections[salestoolkitAsset.containedBy];
        if (collection) {
            let assets = collection.assets;
            assets.sort((a, b) => a.assetOrder - b.assetOrder);
            let siblingIds = assets?.map(x => x.id) || [];
            let currentIndex = siblingIds.findIndex(x => x == salestoolkitAsset.id);
            let indexToLoad = currentIndex - 1;
            if (indexToLoad < 0)
                indexToLoad = assets.length - 1;
            _loadAsset(siblingIds[indexToLoad]);
        }
    }

    /**
     * Navigates to the next asset in the gallery.
     */
    function _navGalleryRight() {
        let collection = SalesToolkit.Library.collections[salestoolkitAsset.containedBy];
        if (collection) {
            let assets = collection.assets;
            assets.sort((a, b) => a.assetOrder - b.assetOrder);
            let siblingIds = assets?.map(x => x.id) || [];
            let currentIndex = siblingIds.findIndex(x => x == salestoolkitAsset.id);
            let indexToLoad = currentIndex + 1;
            if (indexToLoad >= assets.length)
                indexToLoad = 0;
            _loadAsset(siblingIds[indexToLoad]);
        }
    }

    /**
     * Sets up the main preview area, asset details, and UI elements.
     */
    function _setupPreview() {
        const asset = SalesToolkit.Library.assets[salestoolkitAssetId];
        if (asset) {
            document.title = SalesToolkit.Translation.get('salestoolkitViewAssetDocumentTitle', 'Resource Centre | Viewing Asset: {0}').replace('{0}', asset.name);
            document.getElementById('salestoolkit-asset-name').innerHTML = asset.name;

            salestoolkitCollectionId = asset.containedBy;
            window.salestoolkitCollectionId = salestoolkitCollectionId;
            salestoolkitAssetName = asset.name;
            _renderBreadcrumbs();

            SalesToolkit.Theme.setOverridingCollection(salestoolkitCollectionId);
            salestoolkitAsset = asset;

            document.getElementById('salestoolkit-rate-asset-rating-' + _getUserRatingString()).checked = true;
            document.getElementById('salestoolkit-rate-asset-comment').value = SalesToolkit.User.getAssetRatingComment(salestoolkitAssetId);
            document.getElementById('salestoolkit-asset-name-goes-here').innerHTML = salestoolkitAssetName;
            if (document.getElementById('asset-description-message') !== null)
                document.getElementById('asset-description-message').innerHTML = '';

            _populateRelatedAssetsPanel();

            const cartButton = document.getElementById('salestoolkit-asset-cart-button');
            const downloadButton = document.getElementById('salestoolkit-asset-download-button');

            if (salestoolkitAsset && (!salestoolkitAsset.shareByEmail && !SalesToolkit.User.permissions.canRegisterInterest)) {
                cartButton.style.display = "none";
                downloadButton.style.display = "none";
            } else {
                if (SalesToolkit.Theme.getCollectionProperty(salestoolkitAsset.containedBy, 'disallowSharesOverride', 'false') == 'true') {
                    cartButton.style.display = "none";
                } else {
                    cartButton.style.display = "inline-block";
                }

                if (SalesToolkit.Theme.getCollectionProperty(salestoolkitAsset.containedBy, 'disallowDownloadsOverride', 'false') == 'true') {
                    downloadButton.style.display = "none";
                } else {
                    const downloadableMimeTypesList = SalesToolkit.Theme.getCollectionProperty(salestoolkitAsset.containedBy, 'downloadableMimeTypes', "").split(",");
                    downloadButton.style.display = "none";
                    for (let i = 0; i < downloadableMimeTypesList.length; i++) {
                        if (downloadableMimeTypesList[i] == salestoolkitAsset.realFileMimetype) {
                            downloadButton.style.display = "inline-block";
                        }
                    }
                }

                if (false === SalesToolkit.User.permissions.canDownload) {
                    downloadButton.style.display = "none";
                }
            }
            _showAssetPreview();
        } else {
            loadIndexScreen();
        }
    }

    /**
     * Checks if a certification form exists for the asset and displays it.
     */
    function _showCertificateFormIfExists() {
        const certificationForm = SalesToolkit.Forms.getCertificationForm(salestoolkitAssetId);
        if (certificationForm != null) {
            showFormScreen(certificationForm.id, { itemId: salestoolkitAssetId, itemType: 'ASSET' });
        }
    };

    /**
     * Checks for a certification form, shows it if it exists, otherwise triggers the back button action.
     */
    function _showCertificateFormIfExistsOrTriggerBackButtonClick() {
        const certificationForm = SalesToolkit.Forms.getCertificationForm(salestoolkitAssetId);
        if (certificationForm != null) {
            showFormScreen(certificationForm.id, { itemId: salestoolkitAssetId, itemType: 'ASSET' });
        } else {
            _goBack();
        }
    };
    //#endregion

    //#region PDF Tracking
    /**
     * Ends the tracking for the current PDF page view.
     */
    function _endPDFPageTracking() {
        if (PDFViewerTracker.viewStartTime && PDFViewerTracker.currentPage && PDFViewerTracker.assetId) {
            const dwellTime = Date.now() - PDFViewerTracker.viewStartTime;
            if (dwellTime > 500) {
                trackPDFPageViewEnd({
                    pageNumber: PDFViewerTracker.currentPage,
                    assetId: PDFViewerTracker.assetId,
                    dwellTime: dwellTime
                });
            }
        }
        PDFViewerTracker.currentPage = null;
        PDFViewerTracker.viewStartTime = null;
        PDFViewerTracker.assetId = null;
    }

    /**
     * Starts tracking a new PDF page view.
     * @param {number} pageNumber - The page number being viewed.
     */
    function _startPDFPageTracking(pageNumber) {
        _endPDFPageTracking();
        PDFViewerTracker.currentPage = pageNumber;
        PDFViewerTracker.assetId = salestoolkitAssetId;
        PDFViewerTracker.viewStartTime = Date.now();
        trackPDFPageViewStart({
            pageNumber: PDFViewerTracker.currentPage,
            assetId: PDFViewerTracker.assetId
        });
    }
    //#endregion

    //#region Layout Management
    /**
     * Removes all Bootstrap 'col-*' classes from an element.
     * @param {HTMLElement} element - The DOM element to clean.
     */
    function _removeAllColCSS(element) {
        const cl = $(element).attr("class").split(" ");
        let newcl = [];
        for (let i = 0; i < cl.length; i++) {
            let r = cl[i].search(/col-+/);
            if (r) newcl[newcl.length] = cl[i];
        }
        $(element).removeClass().addClass(newcl.join(" "));
    }

   /**
     * Sets up the responsive column layout for the main content and side panels.
     */
    function _setupColumns() {
        _removeAllColCSS(tree);
        _removeAllColCSS(related);

        $(related).addClass('col-lg-' + relatedAssetsLargeCols);
        $(related).addClass('col-md-' + relatedAssetsMediumCols);
        $(related).addClass('col-sm-' + relatedAssetsSmallCols);

        // Corrected check for localStorage string values
        if (localStorage.hideTree !== 'true' && localStorage.hideRelated === 'true') {
            let mainLGSize = 12;
            let mainMDSize = 12;
            let mainSMSize = 12;
            mainLGSize -= treeViewLargeCols;
            mainMDSize -= treeViewMediumCols;
            mainSMSize -= treeViewSmallCols;

            mainLGSize -= treeViewLargeColsExtra;
            mainMDSize -= treeViewMediumColsExtra;
            mainSMSize -= treeViewSmallColsExtra;

            _removeAllColCSS(main);

            $(main).addClass('col-lg-' + mainLGSize);
            $(main).addClass('col-md-' + mainMDSize);
            $(main).addClass('col-sm-' + mainSMSize);

            $(tree).addClass('col-lg-' + (treeViewLargeCols + treeViewLargeColsExtra));
            $(tree).addClass('col-md-' + (treeViewMediumCols + treeViewMediumColsExtra));
            $(tree).addClass('col-sm-' + (treeViewSmallCols + treeViewSmallColsExtra));
        } else {
            $(tree).addClass('col-lg-' + treeViewLargeCols);
            $(tree).addClass('col-md-' + treeViewMediumCols);
            $(tree).addClass('col-sm-' + treeViewSmallCols);
        }
    }

    /**
     * Toggles the visibility of the tree view panel.
     */
    function _toggleTree() {
        let mainLGSize = 12;
        let mainMDSize = 12;
        let mainSMSize = 12;

        if (related.style.display !== 'none') {
            mainLGSize -= relatedAssetsLargeCols;
            mainMDSize -= relatedAssetsMediumCols;
            mainSMSize -= relatedAssetsSmallCols;
        }

        if (tree.style.display === "none") {
            trackAppClick($('#tree-toggler'), '#tree-toggler', 'trackingTreeViewToggleShow', SalesToolkit.Translation.get('trackingTreeViewToggleShow', 'trackingTreeViewToggleShow'));
            delete localStorage['hideTree'];
            tree.style.display = "block";
            mainLGSize -= treeViewLargeCols;
            mainMDSize -= treeViewMediumCols;
            mainSMSize -= treeViewSmallCols;

            if (related.style.display === 'none') {
                mainLGSize -= treeViewLargeColsExtra;
                mainMDSize -= treeViewMediumColsExtra;
                mainSMSize -= treeViewSmallColsExtra;
            }
        } else {
            trackAppClick($('#tree-toggler'), '#tree-toggler', 'trackingTreeViewToggleHide', SalesToolkit.Translation.get('trackingTreeViewToggleHide', 'trackingTreeViewToggleHide'));
            localStorage.hideTree = true;
            tree.style.display = "none";
            main.style.display = "block";
        }

        _removeAllColCSS(main);
        $(main).addClass('col-lg-' + mainLGSize);
        $(main).addClass('col-md-' + mainMDSize);
        $(main).addClass('col-sm-' + mainSMSize);
        _setupColumns();
        _resizeWindow();
    }

    /**
     * Toggles the visibility of the related assets panel.
     */
    function _toggleRelated() {
        let mainLGSize = 12;
        let mainMDSize = 12;
        let mainSMSize = 12;

        if (tree.style.display !== 'none') {
            mainLGSize -= treeViewLargeCols;
            mainMDSize -= treeViewMediumCols;
            mainSMSize -= treeViewSmallCols;
        }

        if (related.style.display === "none") {
            trackAppClick($('#related-toggler'), '#related-toggler', 'trackingRelatedAssetsToggleShow', SalesToolkit.Translation.get('trackingRelatedAssetsToggleShow', 'trackingRelatedAssetsToggleShow'));
            delete localStorage['hideRelated'];
            related.style.display = "block";
            mainLGSize -= relatedAssetsLargeCols;
            mainMDSize -= relatedAssetsMediumCols;
            mainSMSize -= relatedAssetsSmallCols;
        } else {
            trackAppClick($('#related-toggler'), '#related-toggler', 'trackingRelatedAssetsToggleHide', SalesToolkit.Translation.get('trackingRelatedAssetsToggleHide', 'trackingRelatedAssetsToggleHide'));
            localStorage.hideRelated = true;
            related.style.display = "none";
            main.style.display = "block";
            if (tree.style.display !== 'none') {
                mainLGSize -= treeViewLargeColsExtra;
                mainMDSize -= treeViewMediumColsExtra;
                mainSMSize -= treeViewSmallColsExtra;
            }
        }

        _removeAllColCSS(main);
        $(main).addClass('col-lg-' + mainLGSize);
        $(main).addClass('col-md-' + mainMDSize);
        $(main).addClass('col-sm-' + mainSMSize);
        _setupColumns();
    }

    
    //#endregion
    //#region TreeView
     /**
     * Sets up the tree view component and its event listeners.
     */
    function _setupTreeView() {
        salestoolkitTreeView = SalesToolkit.Atheneum.UI.TreeView(document.getElementById('atheneum-tree-view'), SalesToolkit.getHomeCollectionID());

        salestoolkitTreeView.on('item-click', _handleTreeViewItemClick);

        $(salestoolkitTreeView.element).on('loaded.jstree', function () {
            salestoolkitTreeView.viewCollection(SalesToolkit.Library.assets[salestoolkitAssetId].containedBy);
            salestoolkitTreeView.refresh(true);
        });
    }

        /**
         * Handles clicks on items within the tree view.
         * @param {object} item - The clicked tree view item.
         */
        function _handleTreeViewItemClick(item) {
            if (item.type == "collection") {
                 loadIndexScreen(false, false, item.id);
            } else if (item.type == "asset" && item.id != salestoolkitTreeView.selectedAsset) {
                if (SalesToolkit.Library.assets[item.id].mimetype == "asset/url") {
                    SalesToolkit.Pages.openInNewTab(SalesToolkit.Library.assets[item.id].url);
                    return;
                }
                _loadAsset(item.id);
            } else if (item.type == "asset" && item.id == salestoolkitTreeView.selectedAsset && SalesToolkit.Theme.getBooleanProperty('scrollTreeView', false)) {
                setTimeout(function () {
                    const treeViewEl = $('#atheneum-tree-view');
                    treeViewEl.scrollTop(0);
                    const li = $('#' + salestoolkitTreeView.puid + '_collection_' + salestoolkitCollectionId);
                    if (li.length === 0) return;
                    
                    let offsetTop = li.offset().top;
                    let parentOffset = li.offsetParent();
                    while (parentOffset.length > 0 && parentOffset.offset().top > 0) {
                        offsetTop -= parentOffset.offset().top;
                        parentOffset = parentOffset.offsetParent();
                    }
                    offsetTop -= 7; // Adjustment
                    if (offsetTop < 0) offsetTop = 0;

                    treeViewEl.scrollTop(offsetTop);
                }, 350);
            }
            return false;
        }
    //#endregion

    //#region TopBar Menu Functions
    /**
     * Sets up the event listeners for the main action buttons (Favourite, Cart, Download).
     */
    function _setupButtonListeners() {
        $('#salestoolkit-asset-favourite-button').on("click.previewAsset", _handleFavouriteClick);
        $('#salestoolkit-asset-cart-button').on("click.previewAsset", _handleCartClick);
        $('#salestoolkit-asset-download-button').on("click.previewAsset", _handleDownloadClick);

        $('#salestoolkit-asset-tag-button').on("click.previewAsset", _showTagModal);
        $('#salestoolkit-asset-related-button').on("click.previewAsset", _showRelatedAssetsModal);
        
       //TTODO check if needed  $('#relatedDocumentModal').on('show.bs.modal', _showRelatedAssetsModal);

         $('#salestoolkit-asset-info-button').on('click.previewAsset', () => showInformationForItem(salestoolkitAsset));
        $('#salestoolkit-rate-asset-submit').on('click.previewAsset', _handleRateSubmit);
    }

    /**
     * Handles the logic for adding/removing an asset from Favourites.
     */
    function _handleFavouriteClick() {
        $(this).blur();
        const favButton = this;

        const updateUI = (isAdded) => {
            const addText = SalesToolkit.Translation.get("favouritesToggleAdd", "Add to Favourites");
            const removeText = SalesToolkit.Translation.get("favouritesToggleRemove", "Remove from Favourites");
            const newText = isAdded ? removeText : addText;
            const notificationKey = isAdded ? 'notificationFavouritesAdded' : 'notificationFavouritesRemoved';
            const notificationDefault = isAdded ? 'Added {0} to Favourites' : 'Removed {0} from Favourites';
            const notificationBody = SalesToolkit.Translation.getFormatted(notificationKey, notificationDefault, [salestoolkitAssetName]);
            
            SalesToolkit.UI.Notifications.showCustomNotification("favourites", notificationBody);
            
            favButton.setAttribute("data-original-title", newText);
            favButton.setAttribute("title", newText);
            document.getElementById('fav-heart').src = isAdded ? FAVOURITES_HEART_FULL : FAVOURITES_HEART_EMPTY;
            $(favButton).toggleClass("already-clicked", isAdded);
        };

        const isFavourite = SalesToolkit.Favourites.assetIds.includes(salestoolkitAssetId);

        const options = {
            success: () => updateUI(!isFavourite),
            failure: (reason, httpStatus, errorCode) => {
                if (SalesToolkit.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    updateUI(!isFavourite);
                } else {
                    SalesToolkit.Callbacks.logFailureDetails(reason, httpStatus, errorCode);
                }
            }
        };

        if (isFavourite) {
            SalesToolkit.Favourites.removeAsset(salestoolkitCollectionId, salestoolkitAssetId, options);
        } else {
            SalesToolkit.Favourites.addAsset(salestoolkitCollectionId, salestoolkitAssetId, options);
        }
        return false;
    }

    /**
     * Handles the logic for adding/removing an asset from the Cart.
     */
    function _handleCartClick() {
        $(this).blur();
        const cartButton = this;

        const updateUI = (isAdded) => {
            const addText = SalesToolkit.Translation.get("cartToggleAdd", "Add to Cart");
            const removeText = SalesToolkit.Translation.get("cartToggleRemove", "Remove from Cart");
            const newText = isAdded ? removeText : addText;
            const notificationKey = isAdded ? 'notificationCartAdded' : 'notificationCartRemoved';
            const notificationDefault = isAdded ? 'Added {0} to Cart' : 'Removed {0} from Cart';
            const notificationBody = SalesToolkit.Translation.getFormatted(notificationKey, notificationDefault, [salestoolkitAssetName]);

            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            SalesToolkit.UI.Cart.updateMenuCartBadge();

            cartButton.setAttribute("data-original-title", newText);
            cartButton.setAttribute("title", newText);
            document.getElementById('cart-trolley').src = isAdded ? SHOPPING_CART_FULL : SHOPPING_CART_EMPTY;
            $(cartButton).toggleClass("already-clicked", isAdded);
        };

        if (SalesToolkit.Cart.containsAsset(salestoolkitAssetId)) {
            SalesToolkit.Cart.removeAsset(salestoolkitAssetId, { success: () => updateUI(false) });
        } else {
            SalesToolkit.Cart.addAsset(salestoolkitAssetId, { success: () => updateUI(true) });
        }
        return false;
    }

    /**
     * Handles the logic for downloading an asset.
     */
    function _handleDownloadClick() {
        $(this).blur();
        _downloadAsset();
        return false;
    }

    /**
     * Initiates the asset download process with mobile data checks.
     */
    function _downloadAsset() {
        const allowMobileDataDownloads = SalesToolkit.Theme.TRUE_VALUES.includes(SalesToolkit.User.getPreference('salestoolkitAppSettingDownloadOnMobile', 'off', false));
        const maxSizeDownloads = SalesToolkit.User.getPreference('salestoolkitAppSettingMobileMaxSize', '0', false);

        if (SalesToolkit.CrossPlatform.enabled && !SalesToolkit.CrossPlatform.isWiFi() && !allowMobileDataDownloads && SalesToolkit.CrossPlatform.getConnectivityResponse(true) != 0) {
            const documentSize = SalesToolkit.CrossPlatform.getAssetFileSize(salestoolkitAssetId, true);
            if (documentSize !== "unknown") {
                $('#mobileDownloadFileSize').html(SalesToolkit.Translation.getFormatted('estimatedFileSize', 'Estimated file size: {0}', [documentSize]));
            } else {
                $('#mobileDownloadFileSize').html(SalesToolkit.Translation.get('unknownFileSize', 'File size could not be estimated'));
            }

            if (parseFloat(maxSizeDownloads) < parseFloat(documentSize || "0")) {
                $('#initiateMobileDownloadModal').modal('show');
                return;
            }
        }

        const notificationBody = SalesToolkit.Translation.getFormatted('notificationDownloading', '{0} is downloading...', [salestoolkitAssetName]);
        SalesToolkit.UI.Notifications.showCustomNotification("download", notificationBody, undefined, "index.html?startingModule=previewAsset&assetId=" + salestoolkitAssetId);

        SalesToolkit.Library.downloadAsset(salestoolkitAssetId, document.getElementById('salestoolkit-asset-download-button'), {
            failure: (reason, httpStatus, errorCode) => {
                const messageKey = SalesToolkit.Callbacks.isOffline(reason, httpStatus, errorCode) ? 'notificationDownloadingFailedOffline' : 'notificationDownloadingFailed';
                const failureBody = SalesToolkit.Translation.getFormatted(messageKey, '{0} failed to download...', [salestoolkitAssetName]);
                SalesToolkit.UI.Notifications.showCustomNotification("download", failureBody, undefined, "index.html?startingModule=previewAsset&assetId=" + salestoolkitAssetId);
            }
        });
    }

    //#endregion

    //#region Helper Functions
       /**
     * Traverses up the collection hierarchy to find the top-level parent collection.
     * @param {object} collection - The starting collection object.
     * @returns {object} The top-level collection object.
     */
    function _getTopLevelCollectionForCollection(collection) {
        let sectioned = SalesToolkit.Theme.getBooleanProperty('topLevelSectioned', false);
        while (typeof collection !== 'undefined' && typeof collection.containedBy === 'string') {
            let item = SalesToolkit.Library.collections[collection.containedBy];
            if (sectioned && typeof item.containedBy !== 'string')
                break;
            collection = item;
        }
        return collection;
    }

      /**
     * Finds the form designated for user details submission.
     * @returns {object|null} The form object or null if not found.
     */
    function _findUserDetailsForm() {
        const TRUE_VALUES = ['on', 'true', 'y', 'yes', true];
        let form = Object.values(SalesToolkit.Forms.formList).filter(x => x.hasOwnProperty('properties') && x.properties.hasOwnProperty('saveFormDataInSession') && TRUE_VALUES.includes(x.properties.saveFormDataInSession));
        
        if (!form || SalesToolkit.Theme.getStringProperty('noDetailsTimerForm', '').length > 0) {
            form = Object.values(SalesToolkit.Forms.formList).filter(x => x.id == SalesToolkit.Theme.getStringProperty('noDetailsTimerForm', ''));
        }
        
        return (form && form.length > 0) ? form : null;
    }


     /**
     * Parses URL parameters.
     * @returns {object} An object containing key-value pairs of URL parameters.
     */
    function _getUrlVars() {
        const vars = {};
        window.location.href.replace(
            /[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                vars[key] = value;
            }
        );
        return vars;
    }

    /**
     * Gets the user's rating for the current asset as a string.
     * @returns {string} The rating ("1", "2", "3", "4", "5", or "none").
     */
    function _getUserRatingString() {
        let rating = SalesToolkit.User.getAssetRatingNumber(salestoolkitAssetId);
        if (rating == null || isNaN(rating) || rating < 1 || rating > 5) {
            rating = "none";
        }
        return rating + "";
    }

    /**
    * Saves the current PDF page number for the asset.
    * @param {number} pageNo - The page number to save.
    */
    function _savePageNumber(pageNo) {
        console.log('PAGE NUMBER = ' + pageNo + ' for asset id = ' + salestoolkitAssetId);
        if (SalesToolkit.CrossPlatform.enabled) {
            SalesToolkit.CrossPlatform.setPageNumber(pageNo, salestoolkitAssetId);
        }
    }

    /**
     * Handles the back button functionality for the asset preview module.
     */
    function _goBack() {
        if (Array.isArray(assetHistory) && assetHistory.length > 1) {
            assetHistory.pop();
            let assetId = assetHistory.pop();
            _loadAsset(assetId);
            return;
        }

        if (SalesToolkit.Theme.getBooleanProperty('viewAssetBackUsesHistory', false)) {
            if (salestoolkitPageCameFrom == 'cart') {
                let loadedCartId = SalesToolkit.Pages.CurrentPage.getQueryParam("loadedCartId");
                if (loadedCartId) {
                    SalesToolkit.Cart.loadCart(loadedCartId);
                }
            }
            window.history.back();
            return;
        }

         if (salestoolkitPageCameFrom == 'favourites') {
            loadFavouritesScreen();
        } else if (salestoolkitPageCameFrom == 'cart') {
            loadCartScreen();
        } else if (salestoolkitPageCameFrom == 'inbox') {
            window.location = "inbox.html?viewAssetBackButton=true"; //TODOMOD modularise inbox
        } else if (salestoolkitPageCameFrom == 'home') {
            const breadcrumbs = $('.breadsmall');
            const length = breadcrumbs.length;
            let levelsBack = 1;
            if (SalesToolkit.Theme.getBooleanProperty('autoPreviewSingleAssets', false) && SalesToolkit.Library.collections[salestoolkitAsset.containedBy].assets.length == 1) {
                levelsBack++;
            }
            if ((length - levelsBack) < 0) {
                loadIndexScreen(); // Go to root home
            } else {
                // Trigger click on the appropriate breadcrumb link
                breadcrumbs.eq(length - levelsBack).click();
            }
        }
    }
    //#endregion

    //#region Screen Resizing
    /**
     * Recalculates the position and width of the asset summary overlay.
     */
    function _recenterSummary() {
        const assetPreviewImage = document.querySelector('#viewAssetWrapper .assetPreviewImage');
        const assetSummary = document.querySelector('#viewAssetWrapper .assetSummary');

        if (!assetPreviewImage || !assetSummary) return;

        assetSummary.style.left = 0;
        assetSummary.style.left = (assetPreviewImage.offsetLeft - assetSummary.offsetLeft) + 'px';
        assetSummary.style.width = assetPreviewImage.offsetWidth + 'px';
    }

    /**
 * Checks if an element has an automatic width by testing if it shrinks when a maxWidth is applied.
 * @param {HTMLElement} element - The element to check.
 * @returns {boolean} - True if width is considered automatic.
 */
    function _hasAutomaticWidth(element) {
        const prevMaxWidth = element.style.maxWidth;
        const widthBefore = element.offsetWidth;
        element.style.maxWidth = (widthBefore - 1) + "px";
        const widthAfter = element.offsetWidth;
        element.style.maxWidth = prevMaxWidth;
        return widthAfter == widthBefore;
    }

    /**
      * Gets the minimum required width for an element, traversing its children.
      * @param {HTMLElement} element - The element to measure.
      * @returns {number} The minimum required width.
      */
    function _getMinRequiredWidth(element) {
        const elementStyle = element.ownerDocument.defaultView.getComputedStyle(element);

        if(!elementStyle || elementStyle == null)
            return 0;

        if (elementStyle.display == "none")
            return 0;

        if ((_hasAutomaticWidth(element)) && element.children) {
            let width = 0;
            for (let i = 0; i < element.children.length; i++) {
                width = Math.max(width, _getMinRequiredWidth(element.children[i]));
            }
            return width;

        } else {
            return element.offsetWidth || 0;
        }
    }



    /**
     * Calculates the height of the iframe content.
     * @returns {number} The height of the iframe.
     */
    function _getIframeHeight() {
        try {
            const iframe = $('#iframe-holder iframe:not(.ie9-fix)')[0];
            if (!iframe)
                return 0;

            if (iframe.contentDocument || iframe.contentWindow.document) {
                const html = (iframe.contentDocument || iframe.contentWindow.document).querySelector("html");
                const body = (iframe.contentDocument || iframe.contentWindow.document).body;

                const htmlHeight = (html || {}).offsetHeight || 0;
                const bodyHeight = (body || {}).offsetHeight || 0;

                return Math.max(htmlHeight, bodyHeight + 33);
            }

            return 0;
        } catch (e) {
            return 0;
        }
    }


    /**
     * Resizes the window and adjusts the iframe scaling.
     */
    function _resizeWindow() {
        let mainDivBottom = $('#main-div-center').offset().top + $('#main-div-center').outerHeight();
        let treeView = $('#atheneum-tree-view');
        let height = mainDivBottom - treeView.offset().top;
        if (treeView.offset().top + height > window.innerHeight) {
            height = window.innerHeight - treeView.offset().top - 15;
        }

        height -= 6;


        if (SalesToolkit.Theme.getBooleanProperty('scrollTreeView', false)) {
            setTimeout(function () {
                let mainDivBottom = $('#main-panel').offset().top + $('#main-panel').outerHeight();
                let treeView = $('#atheneum-tree-view');
                let height2 = mainDivBottom - treeView.offset().top;

                height2 -= 12;

                if (SalesToolkit.Theme.getBooleanProperty('scrollTreeView', false)) {
                    $('#atheneum-tree-view').height(height2);
                    $('#atheneum-tree-view').css('overflow-y', 'scroll');
                    $('#atheneum-tree-view').parents('.portlet.light').css('padding-bottom', 0);
                    $('#atheneum-tree-view').parents('.portlet.light').css('margin-bottom', 0);
                }
            }, 200);
        }

        const $iframe = $('#iframe-holder iframe:not(.ie9-fix)');
        if ($iframe.length == 0)
            return;

        const availableWidth = $('#iframe-holder').width();
        const iframe = $iframe[0];

        iframe.style.visiblity = "visible";

        if (SalesToolkit.Theme.getCollectionBooleanProperty(salestoolkitCollectionId, 'forceAspectRatio', false)) {
            let aspectRatio = SalesToolkit.Theme.getCollectionProperty(salestoolkitCollectionId, 'assetUrlAsspectRatio', '16/9 !important');
            let maxHeight = $('body').height() - 61 - 30;

            let transformOrigin = "-ms-transform-origin: 0 0; transform-origin: 0px 0px 0px;";
            if (document.documentElement.clientWidth > 1920)
                transformOrigin = "";
            if ($(iframe.parentElement).height() * (16 / 9) > $(iframe.parentElement).width()) {
                iframe.setAttribute("style", "max-height:" + maxHeight + "px; height:auto !important; aspect-ratio: " + aspectRatio + "; " + transformOrigin);
            } else {
                iframe.setAttribute("style", "width:auto !important; aspect-ratio: " + aspectRatio + "; " + transformOrigin);
            }

            let iframeWidth = $(iframe).width();
            let iframeHeight = $(iframe).height();

            let iframeWidthFull = SalesToolkit.Theme.getCollectionProperty(salestoolkitCollectionId, 'assetUrlViewportWidth', '1920');
            let iframeHeightFull = SalesToolkit.Theme.getCollectionProperty(salestoolkitCollectionId, 'assetUrlViewportHeight', '1080');

            if (SalesToolkit.Theme.getBooleanProperty('ignoreViewportConfigAtBiggerSizes', false)) {
                if (iframeWidthFull < document.documentElement.clientWidth || iframeHeightFull < document.documentElement.clientHeight) {
                    return;
                }
            }

            let widthRatio = iframeWidth / iframeWidthFull;
            let heightRatio = iframeHeight / iframeHeightFull;

            $(iframe).width(iframeWidthFull);
            $(iframe).height(iframeHeightFull);

            maxHeight = $('body').height() - 61 - 30;
            maxHeight /= heightRatio;

            let iframeParentWidth = $(iframe.parentElement).width();
            let marginLeft = (iframeParentWidth - (iframeWidthFull * widthRatio)) / 2;
            if (transformOrigin == "")
                marginLeft = "0px";

            iframe.setAttribute("style", "margin-left:" + marginLeft + "px !important; max-height:" + maxHeight + "px !important; transform:scale(" + widthRatio + ", " + heightRatio + ") !important; height:" + iframeHeightFull + "px !important; width:" + iframeWidthFull + "px !important; aspect-ratio: " + aspectRatio + "; " + transformOrigin);


            return;
        }

        const iframeWindow = iframe.contentWindow;
        const iframeDoc = iframe.contentDocument || iframeWindow.document;

        if (iframeDoc == undefined || iframeDoc.body == undefined) {
            iframe.style.visiblity = "hidden";
            return;
        }

        let maxWidth = 0;
        if (iframeDoc.body.children != undefined) {
            for (let i = 0; i < iframeDoc.body.children.length; i++) {
                maxWidth = Math.max(maxWidth, _getMinRequiredWidth(iframeDoc.body.children[i]));
            }
        }

        if (maxWidth == 0) {
            iframe.style.width = "100%";
            iframe.style.transform = "";
            iframe.setAttribute("height", "10");
            iframe.setAttribute("height", _getIframeHeight());
            iframe.parentNode.style.height = (_getIframeHeight() + 16) + "px";
            return;
        }

        if (availableWidth >= (maxWidth + 16)) {
            iframe.style.width = (maxWidth + 16) + "px";
            iframe.style.transform = "";
            iframe.setAttribute("height", "10");
            iframe.setAttribute("height", _getIframeHeight());
            iframe.parentNode.style.height = (_getIframeHeight() + 16) + "px";
            return;
        }

        const iframeBodyStyle = iframeWindow.getComputedStyle(iframeDoc.body);
        if (iframeBodyStyle.marginLeft && iframeBodyStyle.marginLeft.includes("px") && !iframeBodyStyle.marginLeft.includes("calc")) {
            maxWidth += parseFloat(iframeBodyStyle.marginLeft.replace("px", ""));
        }
        if (iframeBodyStyle.marginRight && iframeBodyStyle.marginRight.includes("px") && !iframeBodyStyle.marginRight.includes("calc")) {
            maxWidth += parseFloat(iframeBodyStyle.marginRight.replace("px", ""));
        }

        const scaleFactor = (availableWidth / (maxWidth + 16));
        iframe.setAttribute("height", "10");
        const documentHeight = (iframeDoc.querySelector("html") || {}).offsetHeight || 200;
        let bodyHeight = iframeDoc.body.offsetHeight || 0;

        if (iframeBodyStyle.marginTop && iframeBodyStyle.marginTop.includes("px") && !iframeBodyStyle.marginTop.includes("calc")) {
            bodyHeight += parseFloat(iframeBodyStyle.marginTop.replace("px", ""));
        }
        if (iframeBodyStyle.marginBottom && iframeBodyStyle.marginBottom.includes("px") && !iframeBodyStyle.marginBottom.includes("calc")) {
            bodyHeight += parseFloat(iframeBodyStyle.marginBottom.replace("px", ""));
        }
        if ((bodyHeight + 33) >= documentHeight) {
            bodyHeight = documentHeight;
        }

        const requiredHeight = (bodyHeight * scaleFactor) + 16;
        $iframe.attr('width', maxWidth);
        $iframe[0].setAttribute('height', bodyHeight);
        $iframe.css('width', 'calc(' + (100.0 / scaleFactor).toFixed(3) + '% - 16px)');
        $iframe.css('transform', 'scale(' + scaleFactor.toFixed(4) + ')');
        $iframe.parent().height(requiredHeight);
    }
    //#endregion

     //#region Asset Loading & UI Sync

    /**
     * The main function to load and display an asset and its related UI components.
     * @param {string} assetId - The ID of the asset to load.
     * @param {boolean} [endTracking=false] - Whether to end the tracking for the previous asset.
     */
    function _loadAsset(assetId, endTracking = false) {
        if (!assetId) {
            // Attempt to get from cross-platform environment if available
            try {
                if (SalesToolkit.CrossPlatform.enabled) {
                    const result = JSON.parse(SalesToolkit.CrossPlatform.getAssetInfo());
                    assetId = result.assetId;
                }
            } catch (err) { /* Silently fail */ }
        }

        if (!assetId || !SalesToolkit.Library.assets[assetId]) {
               // Redirect if asset is invalid
            loadIndexScreen();
             const notificationBody = SalesToolkit.Translation.getOrGetThemeKey('invalidAssetLoadingError', 'Invalid asset, please contact support');
            SalesToolkit.UI.Notifications.showCustomNotification("info", notificationBody);
         
            return;
        }
        
        // End any active PDF page tracking before loading a new asset
        _endPDFPageTracking();
        
        if (assetTimer) clearTimeout(assetTimer);

        if (salestoolkitAssetId && endTracking) {
            SalesToolkit.Tracking.finish(Atheneum.Tracking.ViewTypes.ASSET, salestoolkitAssetId);
        }

        // Set main module-level asset variables
        salestoolkitAssetId = assetId;
        salestoolkitAsset = SalesToolkit.Library.assets[assetId];
        salestoolkitCollectionId = salestoolkitAsset.containedBy;
        salestoolkitAssetName = salestoolkitAsset.name;
        salestoolkitPageCameFrom = SalesToolkit.Pages.CurrentPage.getQueryParam("from") || "home";
        // Update UI elements based on the new asset
        _updateButtonStates();
        _updateAllIcons();
        _loadBackText();
        
        if (salestoolkitTreeView) {
            let topLevelFilters = SalesToolkit.Theme.getStringProperty('topLevelNameFilters', '').split(',').filter(Boolean);
            let topLevelCollection = _getTopLevelCollectionForCollection(SalesToolkit.Library.collections[salestoolkitAsset.containedBy]);

            let sectioned = SalesToolkit.Theme.getBooleanProperty('topLevelSectioned', false);
            let sectionedId = topLevelCollection ? topLevelCollection.containedBy : null;
            let refreshTree = false;

            if (topLevelCollection && topLevelFilters.length > 0 && topLevelFilters.some(x => topLevelCollection.name.includes(x))) {
                let filter = topLevelFilters.find(x => topLevelCollection.name.includes(x));
                salestoolkitTreeView.topLevelSectioned = sectioned;
                salestoolkitTreeView.topLevelSectionId = sectionedId;
                salestoolkitTreeView.activeTopLevelFilter = filter;
                salestoolkitTreeView.populateTree();
                refreshTree = true;
            } else if (salestoolkitTreeView.jsTree == null) {
                salestoolkitTreeView.populateTree();
                refreshTree = true;
            }
        }

        // Update tree view selection
        if (salestoolkitTreeView) {
            salestoolkitTreeView.setPath(_getAssetPath());
            if (salestoolkitTreeView.selectedAsset !== salestoolkitAssetId) {
                salestoolkitTreeView.selectAsset(salestoolkitAssetId);
                salestoolkitTreeView.refresh(true);
            }
        }

        // Add to history for back button navigation
        if (!Array.isArray(assetHistory)) assetHistory = [];
        assetHistory.push(salestoolkitAssetId);

        // Render main content
        _renderBreadcrumbs();
        _setupPreview(); // This function already exists and handles showing the asset content
    }

    /**
     * Updates the state and visibility of all action buttons based on the current asset and user permissions.
     */
    function _updateButtonStates() {
        const canRate = SalesToolkit.User.permissions.canRate && !SalesToolkit.Theme.getBooleanProperty('disableRatingFunctionality', false);
        const canTag = SalesToolkit.User.permissions.canTagLibraryContent;
        const canRelate = SalesToolkit.User.permissions.canRelateLibraryContent;
        const canDownload = SalesToolkit.User.permissions.canDownload;
        const canShare = salestoolkitAsset && (salestoolkitAsset.shareByEmail || SalesToolkit.User.permissions.canRegisterInterest);

        // Rating Button
        const rateButton = $('#salestoolkit-asset-rate-button');
        rateButton.toggle(canRate);
        if (canRate) {
            const rating = _getUserRatingString();
            rateButton.toggleClass('already-clicked', rating !== 'none');
        }

        // Tag Button
        $('#salestoolkit-asset-tag-button').toggle(canTag);
        if (canTag) {
            // Logic to enable/disable tag button based on tag data availability
            const tagButton = $('#salestoolkit-asset-tag-button').addClass('disabled');
            if (SalesToolkit.Admin.tags?.length > 0) {
                 tagButton.removeClass('disabled');
            } else {
                SalesToolkit.Admin.updateTags({
                    success: () => tagButton.removeClass('disabled'),
                    failure: () => tagButton.removeClass('disabled')
                });
            }
        }

        // Related Button
        $('#salestoolkit-asset-related-button').toggle(canRelate);

        // Cart and Download Buttons
        const disallowShares = SalesToolkit.Theme.getCollectionProperty(salestoolkitAsset.containedBy, 'disallowSharesOverride', 'false') === 'true';
        const disallowDownloads = SalesToolkit.Theme.getCollectionProperty(salestoolkitAsset.containedBy, 'disallowDownloadsOverride', 'false') === 'true';
        
        $('#salestoolkit-asset-cart-button').toggle(canShare && !disallowShares);
        $('#salestoolkit-asset-download-button').toggle(canDownload && !disallowDownloads);
    }
    
    /**
     * Updates all dynamic icons (Fav, Cart, Tag, Related) at once.
     */
    function _updateAllIcons() {
        // Favourite Icon
        const isFavourite = SalesToolkit.Favourites.assetIds.includes(salestoolkitAssetId);
        $('#fav-heart').attr('src', isFavourite ? FAVOURITES_HEART_FULL : FAVOURITES_HEART_EMPTY);
        
        // Cart Icon
        const inCart = SalesToolkit.Cart.containsAsset(salestoolkitAssetId);
        $('#cart-trolley').attr('src', inCart ? SHOPPING_CART_FULL : SHOPPING_CART_EMPTY);

        // Tag & Related Icons
        _updateTagIcon();
        SalesToolkit.Admin.getRelatedAssetIds(salestoolkitAssetId, (relatedAssetIds) => {
            _updateRelatedIcon(relatedAssetIds);
        });
    }

    /**
     * Updates the text of the back button based on navigation history.
     */
    function _loadBackText() {
        let key = 'previewBack';
        if (Array.isArray(assetHistory) && assetHistory.length > 1) {
            key = 'previewBackAssetHistory';
        } else if (salestoolkitPageCameFrom === 'favourites') {
            key = 'previewBackFavourites';
        } else if (salestoolkitPageCameFrom === 'cart') {
            key = 'previewBackCart';
        }
        $('#previewBackButton span').html(SalesToolkit.Translation.get(key, 'Back'));
    }

    /**
     * Shows the initial library sync modal and updates its progress.
     */
    function _showInitialSync(progressValue, count, total) {
        $("#sync-blocker").show();
        const percentage = Math.floor(progressValue * 100);
        $('#salestoolkit-initial-sync-progress-percentage').text(`${percentage}%`);
        $('#salestoolkit-initial-sync-progress-bar').css('width', `${percentage}%`);
        
        const translationKey = SalesToolkit.Theme.getBooleanProperty("useFlatLibrary", false) ? "initialSyncItemsData" : "initialSyncCollectionData";
        const defaultText = SalesToolkit.Theme.getBooleanProperty("useFlatLibrary", false) ? "Downloaded {0} of {1} items" : "Downloaded {0} of {1} collections";
        $('#salestoolkit-initial-sync-progress-text').text(SalesToolkit.Translation.getFormatted(translationKey, defaultText, [count, total]));

        if (!$("#salestoolkit-initial-sync-modal").hasClass("in")) {
            $("#salestoolkit-initial-sync-modal").modal("show");
        }
    }

    /**
     * Hides the initial library sync modal.
     */
    function _hideInitialSync() {
        if (typeof $("#salestoolkit-initial-sync-modal").modal === 'undefined') {
            setTimeout(_hideInitialSync, 100);
            return;
        }
        $("#sync-blocker").hide();
        $("#salestoolkit-initial-sync-modal").modal("hide");
    }

    //#endregion

       //#region JWPlayer

    /**
     * Handles the event when the video starts playing.
     */
    function _onVideoPlaying() {
        $('#videoSection .assetPreviewMedia').addClass('media-playing');
    }

    /**
     * Handles the event when the video is paused or stops.
     */
    function _onVideoPausedOrStopped() {
        $('#videoSection .assetPreviewMedia').removeClass('media-playing');
        $('#videoSection .assetPreviewMedia').attr('data-media-stopped-at', new Date().getTime() + '');
    }

    //#endregion

    //#region Setup

    /**
    * Dummy function to act as a placeholder for UI updates.
    * @returns {boolean} - Always returns false.
    */
    function _updateItemCartAndFavouritesTagsAndReturnFalse() {
        // This is a dummy function and does nothing.
        return false;
    }

    function _setupIE9Fixes() {
        // IE9 fixes
        setTimeout(function () {
            const iframe = document.createElement("IFRAME");
            iframe.className = 'ie9-fix';
            const lastLi = document.querySelector('.dropdown-language > .dropdown-menu li:last-child');
            if (lastLi) lastLi.appendChild(iframe);
        }, 750);

        const isIE = (navigator.userAgent.indexOf("MSIE") != -1) || (navigator.userAgent.indexOf("Trident") != -1);
        if (isIE) {
            setInterval(function () {
                if (!$('.related-assets-dropdown').hasClass("open")) {
                    $('#iframe-holder').css('width', '');
                } else {
                    $('#iframe-holder').css('width', 'calc(100% - 150px)');
                }
            }, 50);
        }
    }
    /**
    * Sets up an interval to periodically check and fix the dimensions of the asset preview iframe.
    * This is particularly useful for handling content that loads asynchronously within the iframe.
    */
    function _setupIframeDimensionFix() {
        let pageLoadTime = new Date().getTime();
        let ignoreFixIframeDimensions = false;

        fixIframeDimensionsInterval = setInterval(function () {
            let $iframe = $('#iframe-holder iframe:not(.ie9-fix)');
            let isVideoPreview = (window.salestoolkitAsset && (window.salestoolkitAsset.mimetype || "").toLowerCase().startsWith("video/"));

            if ($iframe.length > 0) {
                if (ignoreFixIframeDimensions) return;
                let doc;
                try {
                    doc = $iframe[0].contentDocument || ($iframe[0].contentWindow || {}).document;
                } catch (err) {
                    ignoreFixIframeDimensions = true;
                    clearInterval(fixIframeDimensionsInterval);
                    try {
                        if (isVideoPreview) {
                            $('#iframe-holder').children()[0].style.setProperty("height", $('#iframe-holder').children()[0].style["height"], "important");
                            $iframe[0].style.setProperty("top", "-2px");
                            $iframe[0].style.setProperty("position", "relative");
                            $iframe[0].style.setProperty("left", "-2px");
                            $iframe[0].style.setProperty("width", "calc(100 % - 2px)!important");
                            $iframe[0].style.setProperty("height", "calc(100 % - 2px)!important");
                        }
                    } catch (e) { }
                    return;
                }

                let iframeWindow = $iframe[0].contentWindow;
                if (doc && doc.body && !doc.body.getAttribute("scroll")) {
                    doc.body.setAttribute("scroll", "no");
                    if (!iframeWindow.atheneumOnloadRun) {
                        $(window).resize();
                        setTimeout(() => $(window).resize(), 300);
                    }
                }

                if (!iframeWindow.atheneumOnloadSet) {
                    iframeWindow.atheneumOnloadSet = true;
                    iframeWindow.onload = function () {
                        iframeWindow.atheneumOnloadRun = true;
                        $(window).resize();
                        setTimeout(() => $(window).resize(), 150);
                        setTimeout(() => $(window).resize(), 300);
                    };
                }
            }
            if ((new Date().getTime()) - pageLoadTime > 5000) {
                clearInterval(fixIframeDimensionsInterval);
            }
        }, 100);
    }

/**
     * Initializes the Preview Asset module.
     * @param {string} assetId - The ID of the asset to preview.
     */
    function _init(assetId) {
        console.log('Initializing previewAssetModule...');

         assetHistory = [];
         
        // Make functions globally accessible for inline/external calls
        window.startPDFPageTracking = _startPDFPageTracking;
        window.endPDFPageTracking = _endPDFPageTracking;
        window.toggleTree = _toggleTree;
        window.toggleRelated = _toggleRelated;
        window.savePageNumber = _savePageNumber;
        window.assetTimerFinished = _assetTimerFinished;
        window.globalAssetTimerFinished = _globalAssetTimerFinished;
        window.updateItemCartAndFavouritesTagsAndReturnFalse = _updateItemCartAndFavouritesTagsAndReturnFalse;
         window.addTagsToDocument = _submitTags;
        window.addDocumentsToRelated = _submitRelatedAssets;
          window.cancelRelatedBuild = _cancelRelatedBuild;
           window.onVideoPlaying = _onVideoPlaying;
        window.onVideoPausedOrStopped = _onVideoPausedOrStopped;
        window.populateRelatedAssetsPanel = _populateRelatedAssetsPanel;
        // Store and override the global goBack function
        if (typeof window.goBack === 'function') {
            _originalGoBack = window.goBack;
        }
        window.goBack = _goBack;

        main = document.getElementById("main-panel");
        tree = document.getElementById("tree-view-panel");
        related = document.getElementById("related-assets-panel");

        
        treeViewLargeCols = SalesToolkit.Theme.getIntegerProperty('treeViewPanelLargeCols', 2);
        relatedAssetsLargeCols = SalesToolkit.Theme.getIntegerProperty('relatedAssetsPanelLargeCols', 2);
        treeViewMediumCols = SalesToolkit.Theme.getIntegerProperty('treeViewPanelMediumCols', 3);
        relatedAssetsMediumCols = SalesToolkit.Theme.getIntegerProperty('relatedAssetsPanelMediumCols', 3);
        treeViewSmallCols = SalesToolkit.Theme.getIntegerProperty('treeViewPanelSmallCols', 0);
        relatedAssetsSmallCols = SalesToolkit.Theme.getIntegerProperty('relatedAssetsPanelSmallCols', 0);
        treeViewLargeColsExtra = SalesToolkit.Theme.getIntegerProperty('treeViewExtraSpaceLargeCols', 1);
        treeViewMediumColsExtra = SalesToolkit.Theme.getIntegerProperty('treeViewExtraSpaceMediumCols', 1);
        treeViewSmallColsExtra = SalesToolkit.Theme.getIntegerProperty('treeViewExtraSpaceSmallCols', 0);

        if (SalesToolkit.Theme.getBooleanProperty('showPreviewBackButton', true)) {
            $('#previewBackButton').show();
        } else {
            $('#previewBackButton').hide();
        }

        if (SalesToolkit.Theme.getBooleanProperty('showAssetSummary', false)) {
            if (recenterSummaryObserver) {
                recenterSummaryObserver.disconnect();
            }
            recenterSummaryObserver = new ResizeObserver(_recenterSummary);
            if (main) {
                recenterSummaryObserver.observe(main);
            }
        }

        // --- Event Listeners and Timers ---
        $(window).on('resize.previewAsset', _resizeWindow);
        $('a.fullscreen').on('click.previewAsset', function () { setTimeout(_resizeWindow, 1); });
        $('a.fullscreen').on('click.previewAsset', function () {
            $(this).tooltip('destroy').tooltip({ placement: 'top' });
            const tooltips = document.querySelectorAll("body > .tooltip");
            for (let i = 0; i < tooltips.length; i++) {
                $(tooltips[i]).remove();
            }
        });

        _resizeWindow(); // Initial call

        let modalFixed = false;
        $('#rate').on('shown.bs.modal.previewAsset', function () {
            if (!modalFixed) {
                $(this).find('.modal-content').after('<iframe class="ie9-fix"></iframe>');
                modalFixed = true;
            }
        });

        _setupIframeDimensionFix();
        _setupIE9Fixes();
        _startAssetTimer();
        _setupTreeView();
        _setupButtonListeners();

        breadcrumbs = document.getElementById('salestoolkit-breadcrumbs');
        _renderBreadcrumbs();

        _setupRelatedAssetsPanel();
        _populateRelatedAssetsPanel();

         _setupColumns();

        // Set up library sync callbacks
        libraryUpdateCallbacks = {
            success: function() {
                _hideInitialSync();
                window.librarySyncInProgress = false;
            },
            progress: function(json) {
                // Logic to calculate and show progress
                // This complex logic can be moved into its own helper function if needed
                if (json === "progressStart") return;
                // ... (progress calculation logic)
                _showInitialSync(/* progress args */);
            }
        };

        if (SalesToolkit.Theme.getBooleanProperty("salestoolkitTilesProgressivelyUpdate", false)) {
            SalesToolkit.Cache.onSyncFinished = libraryUpdateCallbacks.progress;
        } else {
             $(".syncbuttontopbar").hide();
        }

        // Initial asset load from URL parameter
        _loadAsset(assetId);

        SalesToolkit.NewsFeed.checkForReplies();

        // Set initial panel visibility from localStorage
        if (localStorage.hideTree === 'true') {
            _toggleTree();
        }
        if (localStorage.hideRelated !== 'true') {
            _toggleRelated();
        }

          _setupSecurityListeners();
        _setupGlobalAPIs();

    }

    /**
     * Destroys the Preview Asset module.
     */
    function _destroy() {
        console.log('Destroying previewAssetModule...');
        if (recenterSummaryObserver) {
            recenterSummaryObserver.disconnect();
            recenterSummaryObserver = null;
        }

        assetHistory = [];
        
        window.salestoolkitCollectionId = null;
        // Clean up global functions
        delete window.startPDFPageTracking;
        delete window.endPDFPageTracking;
        delete window.toggleTree;
        delete window.toggleRelated;
        delete window.savePageNumber;
        delete window.assetTimerFinished;
        delete window.globalAssetTimerFinished;
        delete window.updateItemCartAndFavouritesTagsAndReturnFalse;
        delete window.addTagsToDocument;
        delete window.addDocumentsToRelated;
         delete window.cancelRelatedBuild;
          delete window.onVideoPlaying;
        delete window.onVideoPausedOrStopped;
        delete window.populateRelatedAssetsPanel;
        // Restore original goBack function
        if (_originalGoBack) {
            window.goBack = _originalGoBack;
            _originalGoBack = null;
        } else {
            delete window.goBack;
        }


        // Clean up button listeners
        $('#salestoolkit-asset-favourite-button').off('.previewAsset');
        $('#salestoolkit-asset-cart-button').off('.previewAsset');
        $('#salestoolkit-asset-download-button').off('.previewAsset');

         $('#salestoolkit-asset-tag-button').off('.previewAsset');
        $('#salestoolkit-asset-related-button').off('.previewAsset');

         $('#salestoolkit-asset-info-button').off('.previewAsset');
        $('#salestoolkit-rate-asset-submit').off('.previewAsset');

           // Clean up modal listeners and data
        //TODO check if needed $('#relatedDocumentModal').off('show.bs.modal');
        $('#tagHolder').multiSelect('destroy');


        // Destroy jstree instance to prevent memory leaks
        if(salestoolkitTreeView) {
            // The .off() is needed because jstree doesn't clean up its own delegated events
            $(salestoolkitTreeView.element).off('.jstree'); 
            $(salestoolkitTreeView.element).jstree('destroy');
            salestoolkitTreeView = null;
        }

        // Clean up event listeners
        $(window).off('.previewAsset');
        $('a.fullscreen').off('.previewAsset');
        $('#rate').off('.previewAsset');

        // Clear intervals
        if (fixIframeDimensionsInterval) {
            clearInterval(fixIframeDimensionsInterval);
            fixIframeDimensionsInterval = null;
        }

        if (assetTimer) {
            clearTimeout(assetTimer);
            assetTimer = null;
        }

         if(assetSelector) {
            assetSelector = null;
        }

         if (relatedAssetsDisplay) {
            relatedAssetsDisplay.destroy();
            relatedAssetsDisplay = null;
        }

         SalesToolkit.Cache.onSyncFinished = null;

          // Clean up security listeners and interval
        $('body').off('.previewAsset');
        $(document).off('.previewAsset');
        if (clipboardInterval) {
            clearInterval(clipboardInterval);
        }

        // Clean up global APIs
        //delete top.AtheneumSelfDirectedLookup;
        delete window.showSDLModal;
        delete window.iframeFormId;
        delete window.iframeFormElement;
    }


    //#endregion

    // Expose the public methods and properties
    return {
        init: _init,
        destroy: _destroy,
        templateHTML: _templateHTML,
        navGalleryLeft: _navGalleryLeft,
        navGalleryRight: _navGalleryRight
    };

})();
